// src/components/help-articles/help-articles.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment UIBannerFragment on UIBanner {\n    message\n    heading\n    icon {\n      id\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment AllArticleErrorViewFragment on AllArticlesErrorView {\n    title\n    errorMessage {\n      ...UIBannerFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment ArticleFragment on HelpArticle {\n    helpArticleId\n    title\n    icon {\n      id\n    }\n    product\n    productId\n    hyperlink {\n      value\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment HeadingSectionFragment on HelpArticleHeadingSection {\n    headingText\n    icon {\n      id\n    }\n    hyperlink {\n      value\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment MoreArticleLinkFragment on HelpArticleMoreSection {\n    linkName\n    accessibility\n    icon {\n      id\n    }\n    viewIcon {\n      id\n    }\n    product\n    productId\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment ArticleCardFields on HelpArticleCard {\n    helpArticleHeadingSection {\n      ...HeadingSectionFragment\n    }\n    helpArticlesInCard {\n      ...ArticleFragment\n    }\n    moreHelpArticleLink {\n      ...MoreArticleLinkFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment HelpArticleErrorViewFragment on HelpArticleErrorView {\n    errorMessage\n    errorHeading\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextStandardListItemFragment on EGDSTextStandardListItem {\n    text\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextListItemFragment on EGDSTextListItem {\n    ...EGDSTextStandardListItemFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBulletedListFragment on EGDSBulletedList {\n    listItems {\n      ...EGDSTextListItemFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSHeadingFragment on EGDSHeading {\n    headingType\n    text\n  }\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSParagraphFragment on EGDSParagraph {\n    text\n    style\n  }\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSInlineLinkFragment on EGDSInlineLink {\n    text\n    action {\n      target\n      resource {\n        value\n      }\n      accessibility\n    }\n  }\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    text\n    weight\n  }\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    contents {\n      ...EGDSPlainTextFragment\n      ...EGDSStylizedTextFragment\n      ...EGDSInlineLinkFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextFragment on EGDSText {\n    ...EGDSHeadingFragment\n    ...EGDSParagraphFragment\n    ...EGDSSpannableTextFragment\n    ...EGDSPlainTextFragment\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n    spotLight\n  }\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...EGDSIconFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSGraphicTextFragment on EGDSGraphicText {\n    graphic {\n      ...EGDSGraphicFragment\n    }\n    text\n  }\n\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSOrderedListFragment on EGDSOrderedList {\n    items {\n      ...EGDSSpannableTextFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSUnorderedListFragment on EGDSUnorderedList {\n    items {\n      ...EGDSSpannableTextFragment\n    }\n    listItems {\n      ...EGDSTextListItemFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  fragment HelpArticleSearchErrorViewFragment on HelpArticleSearchErrorView {\n    helpArticleSearchErrorMessage {\n      ...EGDSPlainTextFragment\n      ...EGDSBulletedListFragment\n    }\n    helpArticleSearchSubHeading\n    searchTerm\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n  query ArticleFeedbackQuery($context: ContextInput!) {\n    searchHelpArticles(context: $context) {\n      articleFeedbackSection {\n        heading\n        negativeFeedbackIcon {\n          id\n          title\n        }\n        positiveFeedbackIcon {\n          id\n          title\n        }\n        thankYouMessage\n        thankYouMessageDisplayTimeInMilliSec\n        negativeFeedbackSection {\n          optionsTitle\n          options {\n            errorMessage\n            groupName\n            options {\n              label {\n                text\n              }\n            }\n          }\n          submitButton {\n            primary\n            accessibility\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n  fragment CategoryFragment on HelpArticleHeadingSection {\n    headingText\n    icon {\n      id\n    }\n  }\n"
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _tagged_template_literal([
        "\n  fragment HelpArticleClickStreamAnalyticsFragment on HelpArticleClickStreamAnalytics {\n    event {\n      eventCategory\n      eventName\n      eventType\n      eventVersion\n      actionLocation\n    }\n    article {\n      documentId\n      articleName\n      articleGroup\n      articleLink\n      articleLinkType\n      searchTerm\n    }\n    experience {\n      pageName\n      appName\n      appVersion\n      pageNameDetailed\n    }\n    workFlowList {\n      intent\n      automationStatus\n      product\n      orderLineId\n      channel\n    }\n  }\n"
    ]);
    _templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _tagged_template_literal([
        "\n  fragment ContactUsPreFillFragment on ContactUsPreFill {\n    product\n    category\n  }\n"
    ]);
    _templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSButtonFragment on EGDSButton {\n    primary\n    disabled\n    icon {\n      ...EGDSIconFragment\n    }\n    accessibility\n  }\n  ",
        "\n"
    ]);
    _templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _tagged_template_literal([
        "\n  fragment ContactUsWidgetFragment on HelpArticlesContactUsWidgetSection {\n    headingText\n    contactUsButton {\n      ...EGDSButtonFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBasicOptionFragment on EGDSBasicOption {\n    value\n    selected\n    label\n  }\n"
    ]);
    _templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSOptionFragment on EGDSOption {\n    ...EGDSBasicOptionFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSearchFormSelectActionFragment on EGDSSearchFormSelectAction {\n    options {\n      ...EGDSOptionFragment\n    }\n    apply {\n      ...EGDSButtonFragment\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n    label\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _tagged_template_literal([
        "\n  fragment HelpArticleTableFragment on HelpArticleTable {\n    caption\n    header\n    body {\n      rows {\n        cells {\n          content {\n            ...EGDSPlainTextFragment\n            ...EGDSHeadingFragment\n            ...EGDSInlineLinkFragment\n            ...EGDSSpannableTextFragment\n            ...EGDSStylizedTextFragment\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _tagged_template_literal([
        "\n  fragment HelpArticlePortableTextContentFragment on HelpArticlePortableTextContent {\n    helpArticlePortableTextContent {\n      ...EGDSOrderedListFragment\n      ...EGDSUnorderedListFragment\n      ...EGDSPlainTextFragment\n      ...EGDSStylizedTextFragment\n      ...EGDSInlineLinkFragment\n      ...EGDSSpannableTextFragment\n      ...EGDSHeadingFragment\n      ...EGDSSearchFormSelectActionFragment\n      ...HelpArticleTableFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _tagged_template_literal([
        "\n  fragment ProductFragment on HelpArticleHeadingSection {\n    headingText\n    icon {\n      id\n    }\n  }\n"
    ]);
    _templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _tagged_template_literal([
        "\n  fragment ArticleDataFragment on HelpArticleData {\n    categories {\n      ...CategoryFragment\n    }\n    heading {\n      ...ProductFragment\n    }\n    helpArticleContent {\n      ...HelpArticlePortableTextContentFragment\n    }\n    moreAboutCategory\n    productTitle\n    productId\n    helpArticleClickStreamAnalytics {\n      ...HelpArticleClickStreamAnalyticsFragment\n    }\n    contactUsPreFill {\n      ...ContactUsPreFillFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _tagged_template_literal([
        "\n  query ArticleQuery($context: ContextInput!, $helpArticleSearchRequest: HelpArticlesSearchRequestInput!) {\n    searchHelpArticles(context: $context) {\n      articlesById(helpArticlesSearchRequest: $helpArticleSearchRequest) {\n        ... on HelpArticleData {\n          ...ArticleDataFragment\n        }\n        ... on HelpArticleErrorView {\n          ...HelpArticleErrorViewFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject36 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _tagged_template_literal([
        "\n  fragment MoreArticlesViewFragment on MoreHelpArticles {\n    helpArticlesInDialog {\n      helpArticleHeadingSection {\n        ...HeadingSectionFragment\n      }\n      articlesList {\n        ...ArticleFragment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject37 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _tagged_template_literal([
        "\n  query MoreArticleQuery($context: ContextInput!, $helpArticleSearchRequest: HelpArticlesSearchRequestInput!) {\n    searchHelpArticles(context: $context) {\n      moreArticles(helpArticlesSearchRequest: $helpArticleSearchRequest) {\n        ... on MoreHelpArticles {\n          ...MoreArticlesViewFragment\n        }\n        ... on HelpArticleErrorView {\n          ...HelpArticleErrorViewFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject38 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _tagged_template_literal([
        "\n  query HelpArticlesSearchTermQuery($context: ContextInput!, $helpArticlesSearchRequest: HelpArticlesSearchRequestInput!) {\n    searchHelpArticles(context: $context) {\n      articlesBySearchTerm(helpArticlesSearchRequest: $helpArticlesSearchRequest) {\n        ... on MoreHelpArticles {\n          ...MoreArticlesViewFragment\n        }\n        ... on HelpArticleSearchErrorView {\n          ...HelpArticleSearchErrorViewFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject39 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _tagged_template_literal([
        "\n  fragment ToolBarFragment on HelpArticleHeadingSection {\n    headingText\n    icon {\n      id\n    }\n  }\n"
    ]);
    _templateObject40 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _tagged_template_literal([
        "\n  fragment AllArticlesViewFragment on AllHelpArticles {\n    helpArticleTitle\n    helpArticlesOnHomepage {\n      ...ArticleCardFields\n    }\n    dialogTitleOption {\n      ...ToolBarFragment\n    }\n    helpArticleContactUsWidget {\n      ...ContactUsWidgetFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject41 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _tagged_template_literal([
        "\n  query HelpArticlesQuery($context: ContextInput!) {\n    searchHelpArticles(context: $context) {\n      allArticles {\n        ... on AllHelpArticles {\n          ...AllArticlesViewFragment\n        }\n        ... on AllArticlesErrorView {\n          ...AllArticleErrorViewFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject42 = function _templateObject() {
        return data;
    };
    return data;
}
import React51 from "react";
import { gql as gql43, useQuery as useQuery5 } from "@apollo/client";
import { useBexApi as useBexApi5 } from "@shared-ui/bex-api-context";
import { useLoggerEvents as useLoggerEvents6 } from "@shared-ui/logger-context";
// ../internal/src/utils/logger-events.ts
import { SystemEvent, SystemEventLevel } from "@shared-ui/logger-context";
var EVENTS = {
    HELP_ARTICLE_FEEDBACK_SUBMIT: new SystemEvent(SystemEventLevel.INFO, "HELP_ARTICLE_FEEDBACK_SUBMIT")
};
var stringify = function(obj) {
    var pairs = [];
    if (obj) {
        var keysArr = Object.keys(obj);
        keysArr.forEach(function(key) {
            if (key !== "constructor") {
                pairs.push("".concat(key, "=").concat(obj[key]));
            }
        });
    }
    return pairs.join(" ");
};
var flattenJson = function(obj) {
    var res = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Object.keys(obj).forEach(function(key) {
        if (_type_of(obj[key]) !== "object") {
            res[key] = obj[key];
        } else {
            flattenJson(obj[key], res);
        }
    });
    return res;
};
// src/utils/logger-events.ts
import { SystemEvent as SystemEvent2, SystemEventLevel as SystemEventLevel2 } from "@shared-ui/logger-context";
var EVENTS2 = {
    CLICK_MORE_LINK_INFO: new SystemEvent2(SystemEventLevel2.INFO, "CLICKED_MORE_LINK_INFO"),
    CLICK_ARTICLE_LINK_INFO: new SystemEvent2(SystemEventLevel2.INFO, "CLICKED_ARTICLE_LINK_INFO"),
    ARTICLE_DATA_LOADING_ERROR: new SystemEvent2(SystemEventLevel2.ERROR, "ARTICLE_DATA_LOADING_ERROR"),
    ARTICLE_LOG_INFO: new SystemEvent2(SystemEventLevel2.INFO, "ARTICLE_LOG_INFO"),
    MORE_ARTICLE_DATA_LOADING_ERROR: new SystemEvent2(SystemEventLevel2.ERROR, "MORE_ARTICLE_DATA_LOADING_ERROR"),
    SEARCH_ARTICLE_DATA_LOADING_ERROR: new SystemEvent2(SystemEventLevel2.ERROR, "SEARCH_ARTICLE_DATA_LOADING_ERROR"),
    SEARCH_ARTICLE_WARN: new SystemEvent2(SystemEventLevel2.WARN, "SEARCH_ARTICLE_WARN"),
    ALL_ARTICLE_DATA_LOADING_ERROR: new SystemEvent2(SystemEventLevel2.ERROR, "ALL_ARTICLE_DATA_LOADING_ERROR"),
    TYPEAHEAD_SUGGESTION_INFO: new SystemEvent2(SystemEventLevel2.INFO, "TYPEAHEAD_SUGGESTION_INFO"),
    HELP_ARTICLE_FEEDBACK_SUBMIT: new SystemEvent2(SystemEventLevel2.INFO, "HELP_ARTICLE_FEEDBACK_SUBMIT"),
    HELP_ARTICLE_FEEDBACK_LOADING_ERROR: new SystemEvent2(SystemEventLevel2.ERROR, "HELP_ARTICLE_FEEDBACK_LOADING_ERROR")
};
// src/components/help-articles/_private/__fragments/all-article-error-view.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading2 } from "@egds/react-core/text";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
// src/components/help-articles/_private/__fragments/__fragments/ui-banner.tsx
import React from "react";
import { gql } from "@apollo/client";
import { EGDSBanner } from "@egds/react-core/banner";
import { EGDSIcon } from "@egds/react-core/icons";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSText } from "@egds/react-core/text";
var __fragment = gql(_templateObject());
var UIBanner = function(param) {
    var data = param.data;
    var heading = data.heading, message = data.message, icon = data.icon;
    return /* @__PURE__ */ React.createElement(EGDSBanner, null, /* @__PURE__ */ React.createElement(EGDSSpacing, {
        padding: {
            block: "one"
        }
    }, /* @__PURE__ */ React.createElement(EGDSLayoutFlex, {
        alignItems: "center"
    }, icon && /* @__PURE__ */ React.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */ React.createElement(EGDSSpacing, {
        margin: {
            inlinestart: "four",
            inlineend: "six"
        }
    }, /* @__PURE__ */ React.createElement(EGDSIcon, {
        name: icon.id
    }))), /* @__PURE__ */ React.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */ React.createElement("div", null, heading && /* @__PURE__ */ React.createElement(EGDSHeading, null, heading), /* @__PURE__ */ React.createElement(EGDSText, null, message))))));
};
UIBanner.displayName = "UIBanner";
UIBanner.fragment = __fragment;
// src/components/help-articles/_private/__fragments/all-article-error-view.tsx
var __fragment2 = gql2(_templateObject1(), UIBanner.fragment);
var errorViewMargin = {
    blockend: "six"
};
var AllArticleErrorView = function(param) {
    var data = param.data;
    var title = data.title, errorMessage = data.errorMessage;
    return /* @__PURE__ */ React2.createElement(React2.Fragment, null, /* @__PURE__ */ React2.createElement(EGDSSpacing2, {
        margin: errorViewMargin
    }, /* @__PURE__ */ React2.createElement(Experiment, {
        name: "Search_optimization_using_LLM"
    }, /* @__PURE__ */ React2.createElement(ExperimentControl, null, /* @__PURE__ */ React2.createElement(EGDSHeading2, {
        tag: "h3",
        size: 3
    }, title)), /* @__PURE__ */ React2.createElement(ExperimentVariant, {
        bucket: 1
    }))), /* @__PURE__ */ React2.createElement(UIBanner, {
        data: errorMessage
    }));
};
AllArticleErrorView.displayName = "AllArticleErrorView";
AllArticleErrorView.fragment = __fragment2;
// src/components/help-articles/_private/__fragments/all-articles-view.tsx
import React50, { useEffect as useEffect4 } from "react";
import { gql as gql42 } from "@apollo/client";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing16 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading10 } from "@egds/react-core/text";
import { useExperiment as useExperiment3 } from "@shared-ui/experiment-context";
import { ViewLarge as ViewLarge2, ViewMedium, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
// src/components/help-articles/context/article-context.tsx
import React4, { createContext as createContext2, useContext as useContext2, useState } from "react";
import isEqual from "lodash.isequal";
import { useDialog } from "@shared-ui/dialog-context";
import { useLoggerEvents } from "@shared-ui/logger-context";
// ../internal/src/utils/constants.ts
var KNOWLEDGE_BASE_ARTICLE_LINK_TYPE = "Article";
var EVENT_TYPE = "Interaction";
var EVENT_CATEGORY = "help_center";
var EVENT_VERSION = "1.2.0";
var PAGE_NAME = "Help Articles";
var PAGE_NAME_DETAILED = "Help Articles";
var APP_NAME = "ecp-help-center";
var APP_VERSION = "1.0.0";
var HOME_PAGE = "home_page";
var SEARCH = "from_search";
var ARTICLE_DIALOG = "article_dialog";
var MORE_DIALOG = "more_dialog";
var EVENT_NAME = "help_article_link.selected";
var CONTACT_US_ARTICLE_LINK_TYPE = "Contact Us";
var HELP_ARTICLE_FEEDBACK_EVENT_VERSION = "1.0.0";
var HELP_CENTER_CONTACT_US_SELECTED = "help_center_contact_us.selected";
var HELP_CENTER_CONTACT_US_SELECTED_VERSION = "1.0.0";
var HELP_CENTER_ARTICLE_FEEDBACK_SUBMITTED_EVENT_NAME = "help_article_feedback.submitted";
var ARTICLE_GROUP_FROM_SEARCH_BAR = "search";
var ARTICLE_GROUP_FROM_EXTERNAL_LINK = "From External";
var MORE_ARTICLE_LINK_SELECTED = "help_article_more.selected";
var HELP_ARTICLE_CLOSED_EVENT_NAME = "help_article.closed";
var HELP_ARTICLE_MORE_DIALOG_CLOSE_EVENT_NAME = "help_article_more_dialog.closed";
var HELP_ARTICLE_CLOSED_EVENT_VERSION = "1.0.0";
var HELP_ARTICLE_MORE_DIALOG_CLOSE_EVENT_VERSION = "1.0.0";
var HELP_ARTICLE_NAVIGATION_SELECTED_EVENT_NAME = "help_article_navigation.selected";
var HELP_ARTICLE_NAVIGATION_BAR_EVENT_VERSION = "1.0.0";
var HELP_ARTICLE_MORE_LINK_EVENT_VERSION = "1.0.0";
var HELP_ARTICLE_CATEGORY_CLICKED_EVENT_NAME = "help_article_category.selected";
var HELP_ARTICLE_CATEGORY_EVENT_VERSION = "1.0.0";
// src/components/help-articles/context/caller-context.tsx
import { createContext, useContext } from "react";
var CallerContextType = /* @__PURE__ */ function(CallerContextType2) {
    CallerContextType2[CallerContextType2["HELP_CENTER"] = 0] = "HELP_CENTER";
    CallerContextType2[CallerContextType2["QnA"] = 1] = "QnA";
    return CallerContextType2;
}(CallerContextType || {});
var defaultCallerContextValue = {
    callerContext: 0 /* HELP_CENTER */ ,
    callerContextCallback: function() {
        console.error("caller context's handler not set");
    }
};
var CallerContext = createContext(defaultCallerContextValue);
var useCallerContext = function() {
    return useContext(CallerContext);
};
// src/components/help-articles/context/article-context.tsx
var defaultArticleContextValue = {
    triggerRef: null,
    setTriggerRef: function() {
        console.error("Current button`s ref not set!");
    },
    articleIdentifier: {},
    setArticleIdentifier: function() {
        console.error("Article Search callback not set!!");
    },
    isArticleDialogOpen: false,
    actionLocation: "",
    articleDialogActions: {
        openDialog: function() {
            return console.error("Article Dialog not yet initialized");
        },
        closeDialog: function() {
            return console.error("Article Dialog not yet initialized");
        },
        toggleDialog: function() {
            return console.error("Article Dialog not yet initialized");
        }
    },
    ArticleDialogComponent: /* istanbul ignore next -- @preserve */ function() {
        return null;
    },
    previousArticleId: "",
    setPreviousArticleId: function() {
        console.error("Previous article id not set!!");
    },
    preFillContactUsForm: {
        phoneNumber: "",
        itineraryNumber: "",
        category: "",
        intent: ""
    },
    setPreFillContactUsForm: function() {
        console.error("Pre fill contact us form not set!!");
    },
    articleLink: "",
    isContactUsDialogOpen: false,
    contactUsDialogActions: {
        openDialog: function() {
            return console.error("Contact us Dialog not yet initialized");
        },
        closeDialog: function() {
            return console.error("Contact us Dialog not yet initialized");
        },
        toggleDialog: function() {
            return console.error("Contact us Dialog not yet initialized");
        }
    },
    ContactUsDialogComponent: /* istanbul ignore next -- @preserve */ function() {
        return null;
    }
};
var ArticleContext = createContext2(defaultArticleContextValue);
var useArticle = function() {
    return useContext2(ArticleContext);
};
var ArticleContextProvider = function(param) {
    var children = param.children, onDialogChangeCallback = param.onDialogChangeCallback, dialogId = param.dialogId;
    var callerContext = useCallerContext().callerContext;
    var _useState = _sliced_to_array(useState(null), 2), triggerRef = _useState[0], setTriggerRef = _useState[1];
    var _useState1 = _sliced_to_array(useState({}), 2), internalArticleIdentifier = _useState1[0], setInternalArticleIdentifier = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), previousArticleId = _useState2[0], setPreviousArticleId = _useState2[1];
    var _useState3 = _sliced_to_array(useState({
        phoneNumber: "",
        itineraryNumber: "",
        category: "",
        intent: ""
    }), 2), preFillContactUsForm = _useState3[0], setPreFillContactUsForm = _useState3[1];
    var logEvents = useLoggerEvents(EVENTS2);
    var _useDialog = _sliced_to_array(useDialog(dialogId || "article-dialog"), 3), isArticleDialogOpen = _useDialog[0], articleDialogActions = _useDialog[1], ArticleDialogComponent = _useDialog[2];
    var _useDialog1 = _sliced_to_array(useDialog("contact-us-dialog"), 3), isContactUsDialogOpen = _useDialog1[0], contactUsDialogActions = _useDialog1[1], ContactUsDialogComponent = _useDialog1[2];
    var _useState4 = _sliced_to_array(useState(""), 2), actionLocation = _useState4[0], setActionLocation = _useState4[1];
    var _useState5 = _sliced_to_array(useState(""), 2), articleLink = _useState5[0], setArticleLink = _useState5[1];
    var setArticleIdentifier = function(fields) {
        var _fields_articleIdentifier = fields.articleIdentifier, articleId = _fields_articleIdentifier.articleId, product = _fields_articleIdentifier.product, _fields_articleIdentifier_isCategory = _fields_articleIdentifier.isCategory, isCategory = _fields_articleIdentifier_isCategory === void 0 ? false : _fields_articleIdentifier_isCategory, _fields_articleIdentifier_searchTerm = _fields_articleIdentifier.searchTerm, searchTerm = _fields_articleIdentifier_searchTerm === void 0 ? "" : _fields_articleIdentifier_searchTerm, productId = _fields_articleIdentifier.productId, articleTitle = _fields_articleIdentifier.articleTitle;
        var newArticleIdentifier = {
            articleId: articleId,
            product: product,
            isCategory: isCategory,
            searchTerm: searchTerm,
            productId: productId,
            articleTitle: articleTitle
        };
        if (isEqual(internalArticleIdentifier, newArticleIdentifier)) {
            return;
        }
        setInternalArticleIdentifier(newArticleIdentifier);
        setArticleLink(fields.articleLink || "");
        logEvents.ARTICLE_LOG_INFO.log(stringify(flattenJson(_object_spread({
            message: "New Article presented",
            callerContext: callerContext
        }, newArticleIdentifier))));
        if (callerContext === 1 /* QnA */ ) {
            return;
        }
        if (searchTerm) {
            if (!isArticleDialogOpen) {
                articleDialogActions.openDialog();
                setActionLocation(SEARCH);
            }
        } else if (articleId) {
            if (!isArticleDialogOpen) {
                articleDialogActions.openDialog();
                setActionLocation(HOME_PAGE);
            } else {
                setActionLocation(fields.articleLink ? ARTICLE_DIALOG : MORE_DIALOG);
            }
            logEvents.CLICK_ARTICLE_LINK_INFO.log(stringify(flattenJson({
                message: "Clicked Article link: ".concat(product),
                id: articleId
            })));
        } else if (product) {
            if (!isArticleDialogOpen) {
                articleDialogActions.openDialog();
            }
            logEvents.CLICK_MORE_LINK_INFO.log(stringify(flattenJson({
                message: "Clicked More link: ".concat(product),
                isCategory: isCategory
            })));
        }
        if (onDialogChangeCallback) {
            onDialogChangeCallback(fields.articleIdentifier);
        }
    };
    var articleContext = React4.useMemo(function() {
        return {
            articleIdentifier: internalArticleIdentifier,
            setArticleIdentifier: setArticleIdentifier,
            actionLocation: actionLocation,
            isArticleDialogOpen: isArticleDialogOpen,
            articleDialogActions: articleDialogActions,
            ArticleDialogComponent: ArticleDialogComponent,
            previousArticleId: previousArticleId,
            setPreviousArticleId: setPreviousArticleId,
            articleLink: articleLink,
            isContactUsDialogOpen: isContactUsDialogOpen,
            contactUsDialogActions: contactUsDialogActions,
            ContactUsDialogComponent: ContactUsDialogComponent,
            triggerRef: triggerRef,
            setTriggerRef: setTriggerRef,
            preFillContactUsForm: preFillContactUsForm,
            setPreFillContactUsForm: setPreFillContactUsForm
        };
    }, [
        ArticleDialogComponent,
        ContactUsDialogComponent,
        actionLocation,
        articleDialogActions,
        articleLink,
        contactUsDialogActions,
        internalArticleIdentifier,
        isArticleDialogOpen,
        isContactUsDialogOpen,
        preFillContactUsForm,
        previousArticleId,
        setArticleIdentifier,
        triggerRef
    ]);
    return /* @__PURE__ */ React4.createElement(ArticleContext.Provider, {
        value: articleContext
    }, children);
};
// src/components/help-articles/context/help-articles-query-param-context.tsx
import React5 from "react";
var HelpArticleURLQueryParamsContext = React5.createContext({
    articleId: "",
    product: "",
    isCategory: false
});
var HelpArticlesQueryParamProvider = function(param) {
    var children = param.children, urlSearchParams = param.urlSearchParams;
    var articleId = urlSearchParams.get("articleId" /* ARTICLE_ID */ ) || "";
    var product = urlSearchParams.get("product" /* PRODUCT */ ) || "";
    var productId = urlSearchParams.get("productId" /* PRODUCT_ID */ ) || "";
    var isCategory = Boolean(urlSearchParams.get("isCategory" /* IS_CATEGORY */ )) || false;
    var searchTerm = urlSearchParams.get("searchTerm" /* SEARCH_TERM */ ) || "";
    var inputs;
    if (articleId || product || productId) {
        inputs = {
            articleId: articleId,
            product: product,
            productId: productId,
            isCategory: isCategory,
            searchTerm: searchTerm
        };
    }
    return /* @__PURE__ */ React5.createElement(HelpArticleURLQueryParamsContext.Provider, {
        value: inputs
    }, children);
};
var useHelpArticleURLParamsToQueryInputs = function() {
    return React5.useContext(HelpArticleURLQueryParamsContext);
};
// src/components/help-articles/_private/__fragments/__fragments/article.tsx
import React6, { useCallback } from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSIcon as EGDSIcon2, EGDSIconSize } from "@egds/react-core/icons";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { useExperiment } from "@shared-ui/experiment-context";
var __fragment3 = gql3(_templateObject2());
var articleMargin = {
    blockstart: "two"
};
var Article = function(props) {
    var _props_data_hyperlink;
    var articleRef = React6.useRef(null);
    var anchorRef = React6.useRef(null);
    var _useArticle = useArticle(), setArticleIdentifier = _useArticle.setArticleIdentifier, setPreviousArticleId = _useArticle.setPreviousArticleId, previousArticleId = _useArticle.previousArticleId, searchTerm = _useArticle.articleIdentifier.searchTerm, setTriggerRef = _useArticle.setTriggerRef;
    var _props_data = props.data, product = _props_data.product, productId = _props_data.productId, helpArticleId = _props_data.helpArticleId, title = _props_data.title, icon = _props_data.icon, fromDialog = props.fromDialog;
    var clickOnArticle = useCallback(function() {
        var identifier = searchTerm ? "searchTerm" : "product";
        var _obj;
        setArticleIdentifier({
            articleIdentifier: (_obj = {
                articleId: helpArticleId
            }, _define_property(_obj, identifier, product), _define_property(_obj, "productId", productId), _define_property(_obj, "articleTitle", title), _obj)
        });
        if (fromDialog) {
            setPreviousArticleId(helpArticleId);
        } else {
            setTriggerRef(articleRef);
        }
    }, [
        searchTerm,
        setArticleIdentifier,
        helpArticleId,
        product,
        fromDialog,
        setTriggerRef,
        setPreviousArticleId,
        title
    ]);
    var hyperLink = (_props_data_hyperlink = props.data.hyperlink) === null || _props_data_hyperlink === void 0 ? void 0 : _props_data_hyperlink.value;
    var isArticleCrawlingEnabled = useExperiment("Help_Center_Article_Category_Hyperlinks_Enable_Search_Engine_Crawling").exposure.bucket === 1;
    if (isArticleCrawlingEnabled) {
        return /* @__PURE__ */ React6.createElement(EGDSSpacing3, {
            margin: articleMargin,
            key: "".concat(product, "-").concat(helpArticleId),
            stid: "articleLinks"
        }, /* @__PURE__ */ React6.createElement(EGDSLink, {
            key: "".concat(product).concat(helpArticleId)
        }, /* @__PURE__ */ React6.createElement("a", {
            type: "button",
            key: "".concat(product, "-").concat(helpArticleId),
            href: hyperLink,
            onClick: function(e) {
                clickOnArticle();
                e.preventDefault();
            },
            ref: fromDialog ? function(articleLinkNode) {
                if (helpArticleId === previousArticleId) {
                    articleLinkNode === null || articleLinkNode === void 0 ? void 0 : articleLinkNode.focus();
                }
            } : anchorRef
        }, title, /* @__PURE__ */ React6.createElement(EGDSIcon2, {
            name: icon.id,
            size: EGDSIconSize.SMALL,
            key: "".concat(product, "-").concat(helpArticleId)
        }))));
    }
    return /* @__PURE__ */ React6.createElement(EGDSSpacing3, {
        margin: articleMargin,
        key: "".concat(product, "-").concat(helpArticleId),
        stid: "articleLinks"
    }, /* @__PURE__ */ React6.createElement(EGDSLink, {
        key: "".concat(product).concat(helpArticleId),
        onClick: clickOnArticle
    }, /* @__PURE__ */ React6.createElement("button", {
        type: "button",
        key: "".concat(product, "-").concat(helpArticleId),
        ref: fromDialog ? function(articleLinkNode) {
            if (helpArticleId === previousArticleId) {
                articleLinkNode === null || articleLinkNode === void 0 ? void 0 : articleLinkNode.focus();
            }
        } : articleRef
    }, title, /* @__PURE__ */ React6.createElement(EGDSIcon2, {
        name: icon.id,
        size: EGDSIconSize.SMALL,
        key: "".concat(product, "-").concat(helpArticleId)
    }))));
};
Article.fragment = __fragment3;
Article.displayName = "Article";
// src/components/help-articles/_private/__fragments/__fragments/article-card.tsx
import React9, { useCallback as useCallback3 } from "react";
import { gql as gql6 } from "@apollo/client";
import { EGDSCard, EGDSCardLink } from "@egds/react-core/cards";
import { EGDSIcon as EGDSIcon5, EGDSIconSize as EGDSIconSize4 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing5, EGDSSpacingHr as EGDSSpacingHr2 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading4 } from "@egds/react-core/text";
import { Experiment as Experiment2, ExperimentControl as ExperimentControl2, ExperimentVariant as ExperimentVariant2, useExperiment as useExperiment2 } from "@shared-ui/experiment-context";
// src/components/help-articles/_private/__fragments/__fragments/heading-section.tsx
import React7 from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSIcon as EGDSIcon3, EGDSIconSize as EGDSIconSize2 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading3 } from "@egds/react-core/text";
var __headingfragment = gql4(_templateObject3());
var headingMargin = {
    inline: "three"
};
var HeadingSection = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React7.createElement(EGDSLayoutFlex2, {
        direction: "row"
    }, /* @__PURE__ */ React7.createElement(EGDSLayoutFlexItem2, {
        alignSelf: "center"
    }, data.icon && /* @__PURE__ */ React7.createElement(EGDSSpacing4, null, /* @__PURE__ */ React7.createElement(EGDSIcon3, {
        name: data.icon.id,
        size: EGDSIconSize2.MEDIUM
    }))), /* @__PURE__ */ React7.createElement(EGDSLayoutFlexItem2, {
        alignSelf: "center"
    }, /* @__PURE__ */ React7.createElement(EGDSSpacing4, {
        margin: data.icon ? headingMargin : "unset"
    }, /* @__PURE__ */ React7.createElement(EGDSHeading3, {
        tag: "h3",
        size: 4
    }, data.headingText))));
};
HeadingSection.fragment = __headingfragment;
HeadingSection.displayName = "HeadingSection";
// src/components/help-articles/_private/__fragments/__fragments/more-article-link.tsx
import React8, { useCallback as useCallback2 } from "react";
import { gql as gql5 } from "@apollo/client";
import { EGDSIcon as EGDSIcon4, EGDSIconSize as EGDSIconSize3 } from "@egds/react-core/icons";
import { EGDSLink as EGDSLink2 } from "@egds/react-core/link";
import { EGDSSpacingHr } from "@egds/react-core/spacing";
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";
// src/utils/eg-clickstream-helper.ts
function buildWorkFlowData(input) {
    return input.length > 0 ? input.reduce(function(workFlowList, currentInput) {
        if (currentInput) {
            workFlowList.push({
                intent: currentInput.intent,
                order_line_id: currentInput.orderLineId,
                automation_status: currentInput.automationStatus,
                channel: currentInput.channel,
                product_line: currentInput.product
            });
        }
        return workFlowList;
    }, []) : null;
}
var buildClickstreamAnalyticsEvent = function(clickstreamAnalytics, actionLocation, articleGroup, articleLink) {
    var _clickstreamAnalytics_article, _clickstreamAnalytics_article1, _clickstreamAnalytics_article2;
    var _clickstreamAnalytics_event = clickstreamAnalytics.event, eventName = _clickstreamAnalytics_event.eventName, eventType = _clickstreamAnalytics_event.eventType, eventVersion = _clickstreamAnalytics_event.eventVersion, eventCategory = _clickstreamAnalytics_event.eventCategory;
    var _clickstreamAnalytics_experience = clickstreamAnalytics.experience, pageName = _clickstreamAnalytics_experience.pageName, appName = _clickstreamAnalytics_experience.appName, appVersion = _clickstreamAnalytics_experience.appVersion, pageNameDetailed = _clickstreamAnalytics_experience.pageNameDetailed;
    var work_flow_list = buildWorkFlowData(clickstreamAnalytics.workFlowList);
    return {
        event: {
            event_name: eventName,
            event_version: eventVersion,
            event_type: eventType,
            event_category: eventCategory,
            action_location: actionLocation
        },
        article: _object_spread_props(_object_spread({
            document_id: (_clickstreamAnalytics_article = clickstreamAnalytics.article) === null || _clickstreamAnalytics_article === void 0 ? void 0 : _clickstreamAnalytics_article.documentId,
            article_name: (_clickstreamAnalytics_article1 = clickstreamAnalytics.article) === null || _clickstreamAnalytics_article1 === void 0 ? void 0 : _clickstreamAnalytics_article1.articleName,
            article_group: articleGroup
        }, articleLink ? {
            article_link: articleLink
        } : {}, articleLink ? {
            article_link_type: KNOWLEDGE_BASE_ARTICLE_LINK_TYPE
        } : {}), {
            search_term: (_clickstreamAnalytics_article2 = clickstreamAnalytics.article) === null || _clickstreamAnalytics_article2 === void 0 ? void 0 : _clickstreamAnalytics_article2.searchTerm
        }),
        experience: {
            page_name: pageName,
            app_name: appName,
            app_version: appVersion,
            page_name_detailed: pageNameDetailed
        },
        work_flow_list: {
            work_flow_list: work_flow_list
        }
    };
};
var buildClickstreamAnalyticsForExternalArticles = function(articleLink, articleLinkType, articleName, articleGroup, searchTerm) {
    return {
        event: {
            event_name: EVENT_NAME,
            event_version: EVENT_VERSION,
            event_type: EVENT_TYPE,
            event_category: EVENT_CATEGORY,
            action_location: ARTICLE_DIALOG
        },
        article: {
            article_name: articleName,
            article_group: articleGroup,
            article_link: articleLink,
            article_link_type: articleLinkType,
            search_term: searchTerm
        },
        experience: {
            page_name: PAGE_NAME,
            app_name: APP_NAME,
            app_version: APP_VERSION,
            page_name_detailed: PAGE_NAME_DETAILED
        }
    };
};
var buildClickStreamAnalyticsForContactUsSelectedEvent = function(documentId, articleName, articleGroup, searchTerm) {
    return {
        event: {
            event_name: HELP_CENTER_CONTACT_US_SELECTED,
            event_version: HELP_CENTER_CONTACT_US_SELECTED_VERSION,
            event_type: EVENT_TYPE,
            event_category: EVENT_CATEGORY,
            action_location: ARTICLE_DIALOG
        },
        article: {
            document_id: documentId,
            article_name: articleName,
            article_group: articleGroup,
            search_term: searchTerm
        },
        experience: {
            page_name: PAGE_NAME,
            app_name: APP_NAME,
            app_version: APP_VERSION,
            page_name_detailed: PAGE_NAME_DETAILED
        }
    };
};
var buildClickStreamAnalyticsForArticleFeedbackSubmittedEvent = function(feedback) {
    return {
        event: {
            event_name: HELP_CENTER_ARTICLE_FEEDBACK_SUBMITTED_EVENT_NAME,
            event_version: HELP_ARTICLE_FEEDBACK_EVENT_VERSION,
            event_type: EVENT_TYPE,
            event_category: EVENT_CATEGORY,
            action_location: ARTICLE_DIALOG
        },
        article: {
            document_id: feedback.articleData.documentId,
            article_name: feedback.articleData.articleName,
            article_group: feedback.articleData.articleGroup,
            search_term: feedback.articleData.searchTerm
        },
        experience: {
            page_name: PAGE_NAME,
            app_name: APP_NAME,
            app_version: APP_VERSION,
            page_name_detailed: PAGE_NAME_DETAILED
        },
        feedback: {
            feedback_type: feedback.type,
            feedback_list: feedback.negative_options
        }
    };
};
var buildClickstreamAnalyticsForMoreLinkSubmittedEvent = function(articleGroup, location) {
    return {
        event: {
            event_name: MORE_ARTICLE_LINK_SELECTED,
            event_version: HELP_ARTICLE_MORE_LINK_EVENT_VERSION,
            event_type: EVENT_TYPE,
            event_category: EVENT_CATEGORY,
            action_location: location
        },
        article: {
            article_group: articleGroup
        },
        experience: {
            page_name: PAGE_NAME,
            app_name: APP_NAME,
            app_version: APP_VERSION,
            page_name_detailed: PAGE_NAME_DETAILED
        }
    };
};
var buildClickStreamAnalyticsEventObject = function(eventName, eventVersion, articleData) {
    return {
        event: {
            event_name: eventName,
            event_version: eventVersion,
            event_type: EVENT_TYPE,
            event_category: EVENT_CATEGORY,
            action_location: ARTICLE_DIALOG
        },
        article: {
            document_id: articleData === null || articleData === void 0 ? void 0 : articleData.documentId,
            article_name: articleData === null || articleData === void 0 ? void 0 : articleData.articleName,
            article_group: articleData === null || articleData === void 0 ? void 0 : articleData.articleGroup,
            search_term: articleData === null || articleData === void 0 ? void 0 : articleData.searchTerm
        },
        experience: {
            page_name: PAGE_NAME,
            app_name: APP_NAME,
            app_version: APP_VERSION,
            page_name_detailed: PAGE_NAME_DETAILED
        }
    };
};
var buildClickStreamEventForMoreDialogClose = function(articleGroup, searchTerm) {
    return _object_spread_props(_object_spread({}, buildClickStreamAnalyticsEventObject(HELP_ARTICLE_MORE_DIALOG_CLOSE_EVENT_NAME, HELP_ARTICLE_MORE_DIALOG_CLOSE_EVENT_VERSION)), {
        article: {
            article_group: articleGroup,
            search_term: searchTerm
        }
    });
};
var buildClickStreamAnalyticsForCategoryEvent = function(articleData, category) {
    return {
        event: {
            event_name: HELP_ARTICLE_CATEGORY_CLICKED_EVENT_NAME,
            event_version: HELP_ARTICLE_CATEGORY_EVENT_VERSION,
            event_type: EVENT_TYPE,
            event_category: EVENT_CATEGORY,
            action_location: ARTICLE_DIALOG
        },
        article: {
            document_id: articleData.documentId,
            article_name: articleData.articleName,
            article_group: articleData.articleGroup,
            search_term: articleData.searchTerm
        },
        content_card_list: [
            {
                card_category_name: category
            }
        ],
        experience: {
            page_name: PAGE_NAME,
            app_name: APP_NAME,
            app_version: APP_VERSION,
            page_name_detailed: PAGE_NAME_DETAILED
        }
    };
};
var getArticleGroup = function(articleInfo) {
    var product = articleInfo.product, searchTerm = articleInfo.searchTerm;
    if (!product && searchTerm) {
        return ARTICLE_GROUP_FROM_SEARCH_BAR;
    }
    if (!product && !searchTerm) {
        return ARTICLE_GROUP_FROM_EXTERNAL_LINK;
    }
    return product || "";
};
// src/components/help-articles/_private/__fragments/__fragments/more-article-link.tsx
var __fragment4 = gql5(_templateObject4());
var MoreArticleLink = function(param) {
    var data = param.data;
    var _useArticle = useArticle(), setArticleIdentifier = _useArticle.setArticleIdentifier, setTriggerRef = _useArticle.setTriggerRef;
    var product = data.product, productId = data.productId;
    var moreArticleRef = React8.useRef(null);
    var track = useEgClickstream();
    var handleClick = useCallback2(function() {
        setArticleIdentifier({
            articleIdentifier: {
                product: product,
                productId: productId,
                isCategory: false
            }
        });
        setTriggerRef(moreArticleRef);
        track(buildClickstreamAnalyticsForMoreLinkSubmittedEvent(data.product, HOME_PAGE));
    }, [
        product,
        productId,
        setArticleIdentifier,
        setTriggerRef
    ]);
    return /* @__PURE__ */ React8.createElement(React8.Fragment, null, /* @__PURE__ */ React8.createElement(EGDSSpacingHr, {
        blockMargin: "three"
    }), /* @__PURE__ */ React8.createElement(EGDSLink2, {
        onClick: handleClick,
        key: "".concat(data.linkName, "-").concat(product)
    }, /* @__PURE__ */ React8.createElement("button", {
        type: "button",
        "aria-label": data.accessibility,
        ref: moreArticleRef,
        "data-stid": "articleMoreLink"
    }, /* @__PURE__ */ React8.createElement(EGDSIcon4, {
        name: data.viewIcon.id,
        size: EGDSIconSize3.SMALL,
        key: "firstIcon"
    }), data.linkName, /* @__PURE__ */ React8.createElement(EGDSIcon4, {
        name: data.icon.id,
        size: EGDSIconSize3.SMALL,
        key: "secondIcon"
    }))));
};
MoreArticleLink.fragment = __fragment4;
MoreArticleLink.displayName = "MoreArticleLink";
// src/components/help-articles/_private/__fragments/__fragments/article-card.tsx
var __fragment5 = gql6(_templateObject5(), Article.fragment, HeadingSection.fragment, MoreArticleLink.fragment);
var headingMargin2 = {
    inline: "three"
};
var ArticleCard = function(param) {
    var data = param.data;
    var _data_helpArticleHeadingSection_hyperlink, _data_helpArticleHeadingSection, _data_helpArticleHeadingSection1, _data_helpArticleHeadingSection2, _data_helpArticleHeadingSection3, _data_helpArticleHeadingSection4, _data_helpArticleHeadingSection5;
    var moreHelpArticleLink = data.moreHelpArticleLink;
    var _useArticle = useArticle(), setArticleIdentifier = _useArticle.setArticleIdentifier, setTriggerRef = _useArticle.setTriggerRef;
    var moreArticleRef = React9.useRef(null);
    var anchorRef = React9.useRef(null);
    var hyperLink = data === null || data === void 0 ? void 0 : (_data_helpArticleHeadingSection = data.helpArticleHeadingSection) === null || _data_helpArticleHeadingSection === void 0 ? void 0 : (_data_helpArticleHeadingSection_hyperlink = _data_helpArticleHeadingSection.hyperlink) === null || _data_helpArticleHeadingSection_hyperlink === void 0 ? void 0 : _data_helpArticleHeadingSection_hyperlink.value;
    var handleClick = useCallback3(function() {
        var product = moreHelpArticleLink === null || moreHelpArticleLink === void 0 ? void 0 : moreHelpArticleLink.product;
        var productId = moreHelpArticleLink === null || moreHelpArticleLink === void 0 ? void 0 : moreHelpArticleLink.productId;
        setArticleIdentifier({
            articleIdentifier: {
                product: product,
                productId: productId,
                isCategory: false
            }
        });
        setTriggerRef(moreArticleRef);
    }, [
        moreHelpArticleLink === null || moreHelpArticleLink === void 0 ? void 0 : moreHelpArticleLink.product,
        moreHelpArticleLink === null || moreHelpArticleLink === void 0 ? void 0 : moreHelpArticleLink.productId,
        setArticleIdentifier,
        setTriggerRef
    ]);
    var isArticleCrawlingEnabled = useExperiment2("Help_Center_Article_Category_Hyperlinks_Enable_Search_Engine_Crawling").exposure.bucket === 1;
    if (isArticleCrawlingEnabled) {
        var _data_helpArticleHeadingSection6, _data_helpArticleHeadingSection7, _data_helpArticleHeadingSection8, _data_helpArticleHeadingSection9, _data_helpArticleHeadingSection10;
        return /* @__PURE__ */ React9.createElement(EGDSCard, {
            padded: true,
            border: true,
            onClick: handleClick,
            "data-stid": "newArticleUI"
        }, /* @__PURE__ */ React9.createElement(EGDSCardLink, null, /* @__PURE__ */ React9.createElement("a", {
            type: "button",
            ref: anchorRef,
            href: hyperLink,
            onClick: function(e) {
                return e.preventDefault();
            }
        }, data === null || data === void 0 ? void 0 : (_data_helpArticleHeadingSection6 = data.helpArticleHeadingSection) === null || _data_helpArticleHeadingSection6 === void 0 ? void 0 : _data_helpArticleHeadingSection6.headingText)), /* @__PURE__ */ React9.createElement("div", null, /* @__PURE__ */ React9.createElement(EGDSSpacing5, {
            padding: "one"
        }, /* @__PURE__ */ React9.createElement(EGDSLayoutFlex3, {
            direction: "row"
        }, /* @__PURE__ */ React9.createElement(EGDSLayoutFlexItem3, {
            alignSelf: "center"
        }, (data === null || data === void 0 ? void 0 : (_data_helpArticleHeadingSection7 = data.helpArticleHeadingSection) === null || _data_helpArticleHeadingSection7 === void 0 ? void 0 : _data_helpArticleHeadingSection7.icon) && /* @__PURE__ */ React9.createElement(EGDSSpacing5, null, /* @__PURE__ */ React9.createElement(EGDSIcon5, {
            name: data === null || data === void 0 ? void 0 : (_data_helpArticleHeadingSection8 = data.helpArticleHeadingSection) === null || _data_helpArticleHeadingSection8 === void 0 ? void 0 : _data_helpArticleHeadingSection8.icon.id,
            size: EGDSIconSize4.MEDIUM
        }))), /* @__PURE__ */ React9.createElement(EGDSLayoutFlexItem3, {
            alignSelf: "center",
            minWidth: "full_width"
        }, /* @__PURE__ */ React9.createElement(EGDSSpacing5, {
            margin: (data === null || data === void 0 ? void 0 : (_data_helpArticleHeadingSection9 = data.helpArticleHeadingSection) === null || _data_helpArticleHeadingSection9 === void 0 ? void 0 : _data_helpArticleHeadingSection9.icon) ? headingMargin2 : "unset"
        }, /* @__PURE__ */ React9.createElement(EGDSHeading4, {
            tag: "h3",
            size: 5
        }, data === null || data === void 0 ? void 0 : (_data_helpArticleHeadingSection10 = data.helpArticleHeadingSection) === null || _data_helpArticleHeadingSection10 === void 0 ? void 0 : _data_helpArticleHeadingSection10.headingText))), /* @__PURE__ */ React9.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */ React9.createElement(EGDSSpacing5, null, /* @__PURE__ */ React9.createElement(EGDSIcon5, {
            name: "chevron_right",
            size: EGDSIconSize4.LARGE,
            key: "secondIcon"
        })))))));
    }
    return /* @__PURE__ */ React9.createElement(Experiment2, {
        name: "Help_Center_Article_Card_UI"
    }, /* @__PURE__ */ React9.createElement(ExperimentControl2, null, /* @__PURE__ */ React9.createElement(EGDSCard, {
        padded: true,
        border: true
    }, /* @__PURE__ */ React9.createElement(HeadingSection, {
        data: data.helpArticleHeadingSection
    }), /* @__PURE__ */ React9.createElement(EGDSSpacingHr2, {
        blockMargin: "three"
    }), /* @__PURE__ */ React9.createElement("div", null, data.helpArticlesInCard.map(function(article, articleIndex) {
        return /* @__PURE__ */ React9.createElement(Article, {
            data: article,
            key: "".concat(article).concat(articleIndex)
        });
    })), data.moreHelpArticleLink && /* @__PURE__ */ React9.createElement(MoreArticleLink, {
        data: data.moreHelpArticleLink
    }))), /* @__PURE__ */ React9.createElement(ExperimentVariant2, {
        bucket: 1
    }, /* @__PURE__ */ React9.createElement(EGDSCard, {
        padded: true,
        border: true,
        onClick: handleClick,
        "data-stid": "newArticleUI"
    }, /* @__PURE__ */ React9.createElement(EGDSCardLink, null, /* @__PURE__ */ React9.createElement("button", {
        type: "button",
        ref: moreArticleRef
    }, data === null || data === void 0 ? void 0 : (_data_helpArticleHeadingSection1 = data.helpArticleHeadingSection) === null || _data_helpArticleHeadingSection1 === void 0 ? void 0 : _data_helpArticleHeadingSection1.headingText)), /* @__PURE__ */ React9.createElement("div", null, /* @__PURE__ */ React9.createElement(EGDSSpacing5, {
        padding: "one"
    }, /* @__PURE__ */ React9.createElement(EGDSLayoutFlex3, {
        direction: "row"
    }, /* @__PURE__ */ React9.createElement(EGDSLayoutFlexItem3, {
        alignSelf: "center"
    }, (data === null || data === void 0 ? void 0 : (_data_helpArticleHeadingSection2 = data.helpArticleHeadingSection) === null || _data_helpArticleHeadingSection2 === void 0 ? void 0 : _data_helpArticleHeadingSection2.icon) && /* @__PURE__ */ React9.createElement(EGDSSpacing5, null, /* @__PURE__ */ React9.createElement(EGDSIcon5, {
        name: data === null || data === void 0 ? void 0 : (_data_helpArticleHeadingSection3 = data.helpArticleHeadingSection) === null || _data_helpArticleHeadingSection3 === void 0 ? void 0 : _data_helpArticleHeadingSection3.icon.id,
        size: EGDSIconSize4.MEDIUM
    }))), /* @__PURE__ */ React9.createElement(EGDSLayoutFlexItem3, {
        alignSelf: "center",
        minWidth: "full_width"
    }, /* @__PURE__ */ React9.createElement(EGDSSpacing5, {
        margin: (data === null || data === void 0 ? void 0 : (_data_helpArticleHeadingSection4 = data.helpArticleHeadingSection) === null || _data_helpArticleHeadingSection4 === void 0 ? void 0 : _data_helpArticleHeadingSection4.icon) ? headingMargin2 : "unset"
    }, /* @__PURE__ */ React9.createElement(EGDSHeading4, {
        tag: "h3",
        size: 5
    }, data === null || data === void 0 ? void 0 : (_data_helpArticleHeadingSection5 = data.helpArticleHeadingSection) === null || _data_helpArticleHeadingSection5 === void 0 ? void 0 : _data_helpArticleHeadingSection5.headingText))), /* @__PURE__ */ React9.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */ React9.createElement(EGDSSpacing5, null, /* @__PURE__ */ React9.createElement(EGDSIcon5, {
        name: "chevron_right",
        size: EGDSIconSize4.LARGE,
        key: "secondIcon"
    })))))))));
};
ArticleCard.displayName = "ArticleCard";
ArticleCard.fragment = __fragment5;
// src/components/help-articles/_private/__fragments/article/article-query.tsx
import React42 from "react";
import { gql as gql37, useQuery as useQuery2 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing14 } from "@egds/react-core/spacing";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { useLoggerEvents as useLoggerEvents3 } from "@shared-ui/logger-context";
// ../internal/src/components/error-view/help-article-error-view.tsx
import React10 from "react";
import { gql as gql7 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing6 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading5, EGDSText as EGDSText2 } from "@egds/react-core/text";
var __fragment6 = gql7(_templateObject6());
var helpArticleErrorViewMargin = {
    block: "two"
};
var HelpArticleErrorView = function(param) {
    var data = param.data;
    var errorMessage = data.errorMessage, errorHeading = data.errorHeading;
    return /* @__PURE__ */ React10.createElement(React10.Fragment, null, /* @__PURE__ */ React10.createElement(EGDSSpacing6, {
        margin: helpArticleErrorViewMargin
    }, /* @__PURE__ */ React10.createElement(EGDSHeading5, {
        tag: "h1",
        size: 5
    }, /* @__PURE__ */ React10.createElement(EGDSText2, {
        size: 500,
        weight: "bold"
    }, errorHeading))), /* @__PURE__ */ React10.createElement(EGDSSpacing6, {
        margin: helpArticleErrorViewMargin
    }, /* @__PURE__ */ React10.createElement(EGDSText2, {
        size: 400
    }, errorMessage)));
};
HelpArticleErrorView.displayName = "HelpArticleErrorView";
HelpArticleErrorView.fragment = __fragment6;
// ../internal/src/components/error-view/help-article-search-error-view.tsx
import React28 from "react";
import { gql as gql23 } from "@apollo/client";
import { EGDSSpacingHr as EGDSSpacingHr3 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading7 } from "@egds/react-core/text";
// ../internal/src/components/egds-list/egds-bulleted-list.tsx
import React13 from "react";
import { gql as gql10 } from "@apollo/client";
import { EGDSList } from "@egds/react-core/list";
// ../internal/src/components/egds-list/egds-text-list-item.tsx
import React12 from "react";
import { gql as gql9 } from "@apollo/client";
// ../internal/src/components/egds-list/egds-text-standard-list-item.tsx
import React11 from "react";
import { gql as gql8 } from "@apollo/client";
import { EGDSListItem } from "@egds/react-core/list";
var fragment = gql8(_templateObject7());
var EGDSTextStandardListItem = function(param) {
    var data = param.data;
    var text = data.text;
    return /* @__PURE__ */ React11.createElement(EGDSListItem, null, text);
};
EGDSTextStandardListItem.fragment = fragment;
EGDSTextStandardListItem.displayName = "EGDSTextStandardListItem";
// ../internal/src/components/egds-list/egds-text-list-item.tsx
var fragment2 = gql9(_templateObject8(), EGDSTextStandardListItem.fragment);
var EGDSTextListItem = function(param) {
    var data = param.data;
    switch(data.__typename){
        case "EGDSTextStandardListItem":
            return /* @__PURE__ */ React12.createElement(EGDSTextStandardListItem, {
                data: data
            });
        default:
            return null;
    }
};
EGDSTextListItem.fragment = fragment2;
EGDSTextListItem.displayName = "EGDSTextListItem";
// ../internal/src/components/egds-list/egds-bulleted-list.tsx
var fragment3 = gql10(_templateObject9(), EGDSTextListItem.fragment);
var EGDSBulletedList = function(param) {
    var data = param.data;
    var _data_listItems;
    if ((data === null || data === void 0 ? void 0 : (_data_listItems = data.listItems) === null || _data_listItems === void 0 ? void 0 : _data_listItems.length) === 0) {
        return null;
    }
    return /* @__PURE__ */ React13.createElement(EGDSList, null, data.listItems.map(function(item, key) {
        return /* @__PURE__ */ React13.createElement(EGDSTextListItem, {
            data: item,
            key: key
        });
    }));
};
EGDSBulletedList.displayName = "EGDSBulletedList";
EGDSBulletedList.fragment = fragment3;
// ../internal/src/components/egds-list/egds-ordered-list.tsx
import React26 from "react";
import { gql as gql21 } from "@apollo/client";
import { EGDSList as EGDSList2, EGDSListItem as EGDSListItem2 } from "@egds/react-core/list";
// ../internal/src/components/egds-text/egds-text.tsx
import React22 from "react";
import { gql as gql17 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-heading.tsx
import React14 from "react";
import { gql as gql11 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing7 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading6 } from "@egds/react-core/text";
var fragment4 = gql11(_templateObject10());
var _obj;
var EGDSHeadingStyleMap = (_obj = {}, _define_property(_obj, "H1" /* H1 */ , "h1"), _define_property(_obj, "H2" /* H2 */ , "h2"), _define_property(_obj, "H3" /* H3 */ , "h3"), _define_property(_obj, "H4" /* H4 */ , "h4"), _define_property(_obj, "H5" /* H5 */ , "h5"), _define_property(_obj, "H6" /* H6 */ , "h6"), _define_property(_obj, "H7" /* H7 */ , "h6"), _define_property(_obj, "H8" /* H8 */ , "h6"), _obj);
var _obj1;
var EGDSHeadingSizeMap = (_obj1 = {}, _define_property(_obj1, "H1" /* H1 */ , 3), _define_property(_obj1, "H2" /* H2 */ , 4), _define_property(_obj1, "H3" /* H3 */ , 5), _define_property(_obj1, "H4" /* H4 */ , 6), _define_property(_obj1, "H5" /* H5 */ , 7), _define_property(_obj1, "H6" /* H6 */ , 8), _define_property(_obj1, "H7" /* H7 */ , 8), _define_property(_obj1, "H8" /* H8 */ , 8), _obj1);
var HelpCenterEGDSHeading = function(param) {
    var data = param.data, size = param.size, margin2 = param.margin, padding = param.padding;
    var tag = data.headingType !== null ? EGDSHeadingStyleMap[data.headingType] : void 0;
    var headingSize = size !== null && size !== void 0 ? size : data.headingType == null ? void 0 : EGDSHeadingSizeMap[data.headingType];
    var marginSize = margin2 !== null && margin2 !== void 0 ? margin2 : {
        blockstart: "two"
    };
    var paddingSize = padding !== null && padding !== void 0 ? padding : void 0;
    return /* @__PURE__ */ React14.createElement(EGDSSpacing7, {
        margin: marginSize,
        padding: paddingSize
    }, /* @__PURE__ */ React14.createElement(EGDSHeading6, {
        tag: tag,
        size: headingSize
    }, data.text));
};
HelpCenterEGDSHeading.fragment = fragment4;
HelpCenterEGDSHeading.displayName = "HelpCenterEGDSHeading";
// ../internal/src/components/egds-text/egds-paragraph.tsx
import React15 from "react";
import { gql as gql12 } from "@apollo/client";
import { EGDSParagraph } from "@egds/react-core/text";
var fragment5 = gql12(_templateObject11());
var _obj2;
var EGDSParagraphSizeMap = (_obj2 = {}, _define_property(_obj2, "P1" /* P1 */ , 1), _define_property(_obj2, "P2" /* P2 */ , 2), _define_property(_obj2, "P3" /* P3 */ , 3), _obj2);
var HelpCenterEGDSParagraph = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React15.createElement(EGDSParagraph, {
        size: EGDSParagraphSizeMap[data.style]
    }, data.text);
};
HelpCenterEGDSParagraph.fragment = fragment5;
HelpCenterEGDSParagraph.displayName = "HelpCenterEGDSParagraph";
// ../internal/src/components/egds-text/egds-plain-text.tsx
import React16 from "react";
import { gql as gql13 } from "@apollo/client";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
var fragment6 = gql13(_templateObject12());
var EGDSPlainText = function(param) {
    var data = param.data, align = param.align, inline = param.inline, size = param.size;
    return /* @__PURE__ */ React16.createElement(EGDSText3, {
        align: align,
        inline: inline,
        size: size,
        spacing: "two"
    }, data.text);
};
EGDSPlainText.fragment = fragment6;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/egds-text/egds-spannable-text.tsx
import React21 from "react";
import { gql as gql16 } from "@apollo/client";
import { EGDSParagraph as EGDSParagraph2 } from "@egds/react-core/text";
// ../internal/src/components/egds-text/egds-inline-link.tsx
import React19 from "react";
import { gql as gql14 } from "@apollo/client";
import { Experiment as Experiment3, ExperimentControl as ExperimentControl3, ExperimentVariant as ExperimentVariant3 } from "@shared-ui/experiment-context";
// ../internal/src/components/egds-text/egds-inline-link-control.tsx
import React17, { useCallback as useCallback4 } from "react";
import { EGDSLink as EGDSLink3 } from "@egds/react-core/link";
import { useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
var EGDSInlineLinkControl = function(param) {
    var data = param.data, inline = param.inline;
    var _useArticle = useArticle(), setArticleIdentifier = _useArticle.setArticleIdentifier, articleIdentifier = _useArticle.articleIdentifier, contactUsDialogActions = _useArticle.contactUsDialogActions, articleDialogActions = _useArticle.articleDialogActions;
    var callerContext = useCallerContext().callerContext;
    var isArticle = data.action.resource.value.includes("link") || data.action.resource.value.includes("article") && !data.action.resource.value.includes("taapacademy.expediapartnersolutions.com");
    var isContactUs = data.action.resource.value.includes("contact-us");
    var onClick = useCallback4(function(articleIdInfo, articleLink) {
        setArticleIdentifier({
            articleLink: articleLink,
            articleIdentifier: _object_spread_props(_object_spread({}, articleIdentifier), {
                articleId: articleIdInfo
            })
        });
    }, [
        articleIdentifier,
        setArticleIdentifier
    ]);
    var track = useEgClickstream2();
    var onClickCapture = function(articleLinkType, searchTerm) {
        var articleGroup = getArticleGroup({
            product: articleIdentifier.product,
            searchTerm: articleIdentifier.searchTerm
        });
        track(buildClickstreamAnalyticsForExternalArticles(data.action.resource.value, articleLinkType, data.text, articleGroup, searchTerm));
    };
    if (isArticle) {
        var articleIdInfo = data.action.resource.value.substr(data.action.resource.value.lastIndexOf("/") + 1);
        return /* @__PURE__ */ React17.createElement(EGDSLink3, {
            inline: inline,
            key: data.text
        }, /* @__PURE__ */ React17.createElement("button", {
            type: "button",
            onClick: function() {
                return onClick(articleIdInfo, data.action.resource.value);
            }
        }, data.text));
    }
    if (isContactUs) {
        return /* @__PURE__ */ React17.createElement(EGDSLink3, {
            inline: inline,
            key: data.text
        }, /* @__PURE__ */ React17.createElement("button", {
            type: "button",
            onClick: function() {
                articleDialogActions.closeDialog();
                setTimeout(function() {
                    return contactUsDialogActions.openDialog();
                }, 100);
            },
            onClickCapture: function() {
                return onClickCapture(CONTACT_US_ARTICLE_LINK_TYPE, articleIdentifier.searchTerm);
            }
        }, data.text));
    }
    return /* @__PURE__ */ React17.createElement(EGDSLink3, {
        inline: inline,
        key: data.text
    }, /* @__PURE__ */ React17.createElement("a", {
        href: data.action.resource.value,
        rel: "noopener",
        key: data.action.resource.value,
        onClickCapture: function() {
            return onClickCapture(data.action.target.valueOf(), articleIdentifier.searchTerm);
        },
        target: callerContext === 1 /* QnA */  ? "_blank" : "_self"
    }, data.text));
};
EGDSInlineLinkControl.displayName = "EGDSInlineLinkControl";
// ../internal/src/components/egds-text/egds-inline-link-variant.tsx
import React18 from "react";
import { EGDSLink as EGDSLink4 } from "@egds/react-core/link";
var EGDSInlineLinkVariant = function(param) {
    var data = param.data, inline = param.inline, onLinkClickHandler = param.onLinkClickHandler;
    var onLinkClick = function(event) {
        if (onLinkClickHandler && typeof onLinkClickHandler === "function") {
            onLinkClickHandler(event);
        }
    };
    return /* @__PURE__ */ React18.createElement(EGDSLink4, {
        inline: inline,
        key: data.text
    }, /* @__PURE__ */ React18.createElement("a", {
        href: data.action.resource.value,
        rel: "noopener",
        key: data.action.resource.value,
        onClick: onLinkClick,
        target: data.action.target === "EXTERNAL" /* EXTERNAL */  ? "_blank" : "_self"
    }, data.text));
};
EGDSInlineLinkVariant.displayName = "EGDSInlineLinkVariant";
// ../internal/src/components/egds-text/egds-inline-link.tsx
var fragment7 = gql14(_templateObject13());
var EGDSInlineLink = function(param) {
    var data = param.data, inline = param.inline, onLinkClickHandler = param.onLinkClickHandler;
    return /* @__PURE__ */ React19.createElement(Experiment3, {
        name: "HELPCENTER_ARTICLE_LINK_FIX"
    }, /* @__PURE__ */ React19.createElement(ExperimentControl3, null, /* @__PURE__ */ React19.createElement(EGDSInlineLinkControl, _object_spread({}, {
        data: data,
        inline: inline
    }))), /* @__PURE__ */ React19.createElement(ExperimentVariant3, {
        bucket: 1
    }, /* @__PURE__ */ React19.createElement(EGDSInlineLinkVariant, _object_spread({}, {
        data: data,
        inline: inline,
        onLinkClickHandler: onLinkClickHandler
    }))));
};
EGDSInlineLink.fragment = fragment7;
EGDSInlineLink.displayName = "EGDSInlineLink";
// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React20 from "react";
import { gql as gql15 } from "@apollo/client";
import { EGDSText as EGDSText4 } from "@egds/react-core/text";
var fragment8 = gql15(_templateObject14());
var _obj3;
var EGDSTextWeightMap = Object.freeze((_obj3 = {}, _define_property(_obj3, "BOLD" /* BOLD */ , "bold"), _define_property(_obj3, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj3, "REGULAR" /* REGULAR */ , "regular"), _obj3));
var EGDSStylizedText = function(param) {
    var data = param.data, inline = param.inline;
    return /* @__PURE__ */ React20.createElement(EGDSText4, {
        weight: data.weight ? EGDSTextWeightMap[data.weight] : void 0,
        inline: inline,
        spacing: "two"
    }, data.text);
};
EGDSStylizedText.fragment = fragment8;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/egds-text/egds-spannable-text.tsx
var fragment9 = gql16(_templateObject15(), EGDSPlainText.fragment, EGDSStylizedText.fragment, EGDSInlineLink.fragment);
var SpannableTextComponentMap = {
    EGDSPlainText: EGDSPlainText,
    EGDSStylizedText: EGDSStylizedText,
    EGDSInlineLink: EGDSInlineLink
};
var SpannableTextComponentStyleMap = {
    EGDSPlainText: {
        inline: true
    },
    EGDSStylizedText: {
        inline: true
    },
    EGDSInlineLink: {
        inline: true
    }
};
var EGDSSpannableText = function(param) {
    var data = param.data, onLinkClickHandler = param.onLinkClickHandler;
    var _data_contents;
    return /* @__PURE__ */ React21.createElement(EGDSParagraph2, null, /* @__PURE__ */ React21.createElement("span", null, (_data_contents = data.contents) === null || _data_contents === void 0 ? void 0 : _data_contents.map(function(element, index) {
        var SpannableTextComponent = SpannableTextComponentMap[element.__typename];
        if (!SpannableTextComponent) {
            return null;
        }
        if (element.__typename === "EGDSInlineLink") {
            return /* @__PURE__ */ React21.createElement(SpannableTextComponent, _object_spread({
                data: element,
                key: index
            }, SpannableTextComponentStyleMap[element.__typename], {
                onLinkClickHandler: onLinkClickHandler
            }));
        }
        return /* @__PURE__ */ React21.createElement(SpannableTextComponent, _object_spread({
            data: element,
            key: index
        }, SpannableTextComponentStyleMap[element.__typename]));
    })));
};
EGDSSpannableText.fragment = fragment9;
EGDSSpannableText.displayName = "EGDSSpannableText";
// ../internal/src/components/egds-text/egds-text.tsx
var fragment10 = gql17(_templateObject16(), HelpCenterEGDSParagraph.fragment, EGDSPlainText.fragment, HelpCenterEGDSHeading.fragment, EGDSSpannableText.fragment);
var TextComponentMap = {
    EGDSParagraph: HelpCenterEGDSParagraph,
    EGDSHeading: HelpCenterEGDSHeading,
    EGDSSpannableText: EGDSSpannableText,
    EGDSPlainText: EGDSPlainText
};
var HelpCenterEGDSText = function(param) {
    var data = param.data, align = param.align;
    var TextComponent = TextComponentMap[data.__typename];
    if (!TextComponent) {
        return null;
    }
    return /* @__PURE__ */ React22.createElement(TextComponent, {
        align: align,
        data: data
    });
};
HelpCenterEGDSText.fragment = fragment10;
HelpCenterEGDSText.displayName = "HelpCenterEGDSText";
// ../internal/src/components/egds-text/egds-graphic-text.tsx
import React25 from "react";
import { gql as gql20 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex4, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { EGDSText as EGDSText5 } from "@egds/react-core/text";
// ../internal/src/components/egds-graphic/egds-icon.tsx
import React23 from "react";
import { gql as gql18 } from "@apollo/client";
import { EGDSIcon as EGDSIcon6, EGDSIconSize as EGDSIconSize5 } from "@egds/react-core/icons";
var __EGDSIconFragment = gql18(_templateObject17());
var mapSpotlight = function(spotlight) {
    if (!spotlight) {
        return void 0;
    }
    switch(spotlight){
        case "STANDARD" /* STANDARD */ :
            return "standard";
        case "POSITIVE" /* POSITIVE */ :
            return "positive";
        case "WARNING" /* WARNING */ :
            return "warning";
        case "INFO" /* INFO */ :
            return "info";
        default:
            return void 0;
    }
};
var HelpCenterEGDSIcon = function(param) {
    var data = param.data, size = param.size;
    var iconName = data ? data.id : "";
    var finalSize = size !== null && size !== void 0 ? size : (data === null || data === void 0 ? void 0 : data.size) && EGDSIconSize5[data.size];
    var spotlight = data === null || data === void 0 ? void 0 : data.spotLight;
    var _data_theme;
    return /* @__PURE__ */ React23.createElement(EGDSIcon6, {
        name: iconName,
        size: finalSize,
        theme: (_data_theme = data === null || data === void 0 ? void 0 : data.theme) !== null && _data_theme !== void 0 ? _data_theme : void 0,
        spotlight: mapSpotlight(spotlight)
    });
};
HelpCenterEGDSIcon.displayName = "HelpCenterEGDSIcon";
HelpCenterEGDSIcon.fragment = __EGDSIconFragment;
// ../internal/src/components/egds-graphic/egds-graphic.tsx
import React24 from "react";
import { gql as gql19 } from "@apollo/client";
var __EGDSGraphicFragment = gql19(_templateObject18(), HelpCenterEGDSIcon.fragment);
var EGDSGraphic = function(param) {
    var data = param.data;
    switch(data.__typename){
        case "Icon":
            return /* @__PURE__ */ React24.createElement(HelpCenterEGDSIcon, {
                data: data
            });
        default:
            return null;
    }
};
EGDSGraphic.displayName = "EGDSGraphic";
EGDSGraphic.fragment = __EGDSGraphicFragment;
// ../internal/src/components/egds-text/egds-graphic-text.tsx
var fragment11 = gql20(_templateObject19(), EGDSGraphic.fragment);
var EGDSGraphicText = function(param) {
    var data = param.data, textSize = param.textSize, textWeight = param.textWeight, textTheme = param.textTheme, direction = param.direction;
    var graphic = data.graphic, text = data.text;
    return /* @__PURE__ */ React25.createElement(EGDSLayoutFlex4, {
        direction: direction
    }, /* @__PURE__ */ React25.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */ React25.createElement(EGDSText5, {
        size: textSize,
        theme: textTheme,
        weight: textWeight
    }, text)), /* @__PURE__ */ React25.createElement(EGDSLayoutFlexItem4, null, data.graphic && /* @__PURE__ */ React25.createElement(EGDSGraphic, {
        data: data.graphic
    })));
};
EGDSGraphicText.fragment = fragment11;
EGDSGraphicText.displayName = "EGDSGraphicText";
// ../internal/src/components/egds-list/egds-ordered-list.tsx
var fragment12 = gql21(_templateObject20(), EGDSSpannableText.fragment);
var EGDSOrderedList = function(props) {
    var items = props.data.items, onLinkClickHandler = props.onLinkClickHandler, listProps = _object_without_properties(props, [
        "data",
        "onLinkClickHandler"
    ]);
    if (!items.length) {
        return null;
    }
    return /* @__PURE__ */ React26.createElement(EGDSList2, _object_spread({}, listProps), items.map(function(item, index) {
        return /* @__PURE__ */ React26.createElement(EGDSListItem2, {
            key: index
        }, item.__typename === "EGDSSpannableText" && /* @__PURE__ */ React26.createElement(EGDSSpannableText, _object_spread({
            data: item
        }, {
            onLinkClickHandler: onLinkClickHandler
        })));
    }));
};
EGDSOrderedList.fragment = fragment12;
EGDSOrderedList.displayName = "EGDSOrderedList";
// ../internal/src/components/egds-list/egds-unordered-list.tsx
import React27 from "react";
import { gql as gql22 } from "@apollo/client";
import { EGDSList as EGDSList3, EGDSListItem as EGDSListItem3 } from "@egds/react-core/list";
var fragment13 = gql22(_templateObject21(), EGDSSpannableText.fragment, EGDSTextListItem.fragment);
var EGDSUnorderedList = function(props) {
    var _props_data = props.data, items = _props_data.items, listItems = _props_data.listItems, onLinkClickHandler = props.onLinkClickHandler, listProps = _object_without_properties(props, [
        "data",
        "onLinkClickHandler"
    ]);
    if (!listItems.length && !items.length) {
        return null;
    }
    return /* @__PURE__ */ React27.createElement(EGDSList3, _object_spread({}, listProps), items.length > 0 && items.map(function(item, index) {
        return /* @__PURE__ */ React27.createElement(EGDSListItem3, {
            key: index
        }, item.__typename === "EGDSSpannableText" && /* @__PURE__ */ React27.createElement(EGDSSpannableText, _object_spread({
            data: item
        }, {
            onLinkClickHandler: onLinkClickHandler
        })));
    }), listItems.length > 0 && listItems.map(function(item, index) {
        return /* @__PURE__ */ React27.createElement(EGDSTextListItem, _object_spread({
            key: index,
            data: item
        }, {
            onLinkClickHandler: onLinkClickHandler
        }));
    }));
};
EGDSUnorderedList.fragment = fragment13;
EGDSUnorderedList.displayName = "EGDSUnorderedList";
// ../internal/src/components/error-view/help-article-search-error-view.tsx
var __fragment7 = gql23(_templateObject22(), EGDSBulletedList.fragment, EGDSPlainText.fragment);
var ComponentMap = {
    EGDSPlainText: EGDSPlainText,
    EGDSBulletedList: EGDSBulletedList
};
var ComponentStyleMap = {
    EGDSUnorderedList: {
        type: "unordered"
    }
};
var HelpArticleSearchErrorView = function(param) {
    var data = param.data;
    var helpArticleSearchErrorMessage = data.helpArticleSearchErrorMessage, helpArticleSearchSubHeading = data.helpArticleSearchSubHeading, searchTerm = data.searchTerm;
    return /* @__PURE__ */ React28.createElement(React28.Fragment, null, /* @__PURE__ */ React28.createElement(EGDSHeading7, {
        size: 3
    }, searchTerm), /* @__PURE__ */ React28.createElement(EGDSSpacingHr3, {
        blockMargin: "three"
    }), /* @__PURE__ */ React28.createElement(EGDSHeading7, {
        size: 6
    }, helpArticleSearchSubHeading), helpArticleSearchErrorMessage.map(function(element, index) {
        var Component = element && ComponentMap[element.__typename];
        if (!Component) {
            return null;
        }
        return /* @__PURE__ */ React28.createElement(Component, _object_spread({
            data: element,
            key: index
        }, ComponentStyleMap[element.__typename]));
    }));
};
HelpArticleSearchErrorView.displayName = "HelpArticleSearchErrorView";
HelpArticleSearchErrorView.fragment = __fragment7;
// ../internal/src/components/sheet/sheet-loader.tsx
import React29 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex5, EGDSLayoutFlexItem as EGDSLayoutFlexItem5 } from "@egds/react-core/layout-flex";
import { EGDSLoader } from "@egds/react-core/loader";
var SheetLoader = function(props) {
    return /* @__PURE__ */ React29.createElement(EGDSLayoutFlex5, {
        justifyContent: "center",
        blockSize: "full_size"
    }, /* @__PURE__ */ React29.createElement(EGDSLayoutFlexItem5, {
        alignSelf: "center"
    }, /* @__PURE__ */ React29.createElement(EGDSLoader, _object_spread({}, props))));
};
// src/components/help-articles/_private/__fragments/article/__fragments/article-content-view.tsx
import React41, { useCallback as useCallback8 } from "react";
import { gql as gql36 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex9 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing13, EGDSSpacingHr as EGDSSpacingHr5 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText9 } from "@egds/react-core/text";
import { useEgClickstream as useEgClickstream6 } from "@shared-ui/clickstream-analytics-context";
// src/components/help-articles/_private/__fragments/article/__fragments/__fragments/article-feedback-view.tsx
import React31, { useEffect } from "react";
import { gql as gql24, useQuery } from "@apollo/client";
import { EGDSPrimaryButton as EGDSPrimaryButton2 } from "@egds/react-core/button";
import { EGDSCheckbox, EGDSCheckboxGroup } from "@egds/react-core/checkbox";
import { EGDSForm } from "@egds/react-core/form";
import { EGDSSpacing as EGDSSpacing9 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading8, EGDSText as EGDSText6 } from "@egds/react-core/text";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useEgClickstream as useEgClickstream3 } from "@shared-ui/clickstream-analytics-context";
import { useLoggerEvents as useLoggerEvents2 } from "@shared-ui/logger-context";
// src/components/help-articles/_private/__fragments/article/__fragments/__fragments/article-rating.tsx
import React30 from "react";
import { EGDSPrimaryButton, EGDSSecondaryButton } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon7 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex6, EGDSLayoutFlexItem as EGDSLayoutFlexItem6 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing8 } from "@egds/react-core/spacing";
var marginInnerFeedbackView = {
    block: "two"
};
var ArticleRating = function(props) {
    var positiveFeedbackIcon = props.positiveFeedbackIcon, negativeFeedbackIcon = props.negativeFeedbackIcon, positiveFeedbackAriaLabel = props.positiveFeedbackAriaLabel, negativeFeedbackAriaLabel = props.negativeFeedbackAriaLabel, _props_disabled = props.disabled, disabled = _props_disabled === void 0 ? false : _props_disabled, onChange = props.onChange;
    var _React30_useState = _sliced_to_array(React30.useState(false), 2), up = _React30_useState[0], setUp = _React30_useState[1];
    var _React30_useState1 = _sliced_to_array(React30.useState(false), 2), down = _React30_useState1[0], setDown = _React30_useState1[1];
    return /* @__PURE__ */ React30.createElement(EGDSSpacing8, {
        margin: marginInnerFeedbackView
    }, /* @__PURE__ */ React30.createElement(EGDSLayoutFlex6, {
        space: "two"
    }, /* @__PURE__ */ React30.createElement(EGDSLayoutFlexItem6, null, up ? /* @__PURE__ */ React30.createElement(EGDSPrimaryButton, {
        type: "button",
        disabled: disabled,
        onClick: function() {
            setUp(false);
            onChange("NEUTRAL" /* NEUTRAL */ );
        }
    }, /* @__PURE__ */ React30.createElement(EGDSIcon7, {
        name: positiveFeedbackIcon,
        key: "icon"
    })) : /* @__PURE__ */ React30.createElement(EGDSSecondaryButton, {
        type: "button",
        disabled: disabled,
        onClick: function() {
            setUp(true);
            setDown(false);
            onChange("POSITIVE" /* POSITIVE */ );
        },
        "aria-label": positiveFeedbackAriaLabel
    }, /* @__PURE__ */ React30.createElement(EGDSIcon7, {
        name: positiveFeedbackIcon,
        key: "icon"
    }))), /* @__PURE__ */ React30.createElement(EGDSLayoutFlexItem6, null, down ? /* @__PURE__ */ React30.createElement(EGDSPrimaryButton, {
        type: "button",
        disabled: disabled,
        onClick: function() {
            setDown(false);
            onChange("NEUTRAL" /* NEUTRAL */ );
        }
    }, /* @__PURE__ */ React30.createElement(EGDSIcon7, {
        name: negativeFeedbackIcon,
        key: "icon"
    })) : /* @__PURE__ */ React30.createElement(EGDSSecondaryButton, {
        type: "button",
        disabled: disabled,
        onClick: function() {
            setDown(true);
            setUp(false);
            onChange("NEGATIVE" /* NEGATIVE */ );
        },
        "aria-label": negativeFeedbackAriaLabel
    }, /* @__PURE__ */ React30.createElement(EGDSIcon7, {
        name: negativeFeedbackIcon,
        key: "icon"
    })))));
};
// src/components/help-articles/_private/__fragments/article/__fragments/__fragments/article-feedback-view.tsx
var marginFeedbackView = {
    block: "four"
};
var marginInnerFeedbackView2 = {
    block: "two"
};
var __ArticleFeedbackQuery = gql24(_templateObject23());
var ArticleFeedbackView = function() {
    var track = useEgClickstream3();
    var logEvents = useLoggerEvents2(EVENTS2);
    var context = useBexApi().context;
    var articleIdentifier = useArticle().articleIdentifier;
    var _React31_useState = _sliced_to_array(React31.useState(false), 2), showThankYouMessage = _React31_useState[0], setShowThankYouMessage = _React31_useState[1];
    var _React31_useState1 = _sliced_to_array(React31.useState(false), 2), disableFeedbackButtons = _React31_useState1[0], setDisableFeedbackButtons = _React31_useState1[1];
    var _React31_useState2 = _sliced_to_array(React31.useState([]), 2), selectedFeedbackOptions = _React31_useState2[0], setSelectedFeedbackOptions = _React31_useState2[1];
    var _React31_useState3 = _sliced_to_array(React31.useState(false), 2), showFeedbackOptions = _React31_useState3[0], setShowFeedbackOptions = _React31_useState3[1];
    var variables = {
        context: context
    };
    var _useQuery = useQuery(__ArticleFeedbackQuery, {
        variables: variables,
        ssr: false
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    useEffect(function() {
        var _data_searchHelpArticles_articleFeedbackSection;
        var initFeedbackOptions = [];
        data === null || data === void 0 ? void 0 : (_data_searchHelpArticles_articleFeedbackSection = data.searchHelpArticles.articleFeedbackSection) === null || _data_searchHelpArticles_articleFeedbackSection === void 0 ? void 0 : _data_searchHelpArticles_articleFeedbackSection.negativeFeedbackSection.options.options.forEach(function(option) {
            initFeedbackOptions.push({
                label: option.label.text,
                checked: false
            });
        });
        setSelectedFeedbackOptions(initFeedbackOptions);
    }, [
        data
    ]);
    if (loading) {
        return null;
    }
    if (error || !data || !data.searchHelpArticles || !data.searchHelpArticles.articleFeedbackSection) {
        logEvents.HELP_ARTICLE_FEEDBACK_LOADING_ERROR.log(stringify(flattenJson({
            message: "Fail to load feedback options: ".concat(error)
        })));
        return null;
    }
    var _data_searchHelpArticles_articleFeedbackSection = data.searchHelpArticles.articleFeedbackSection, thankYouMessageDisplayTimeInMilliSec = _data_searchHelpArticles_articleFeedbackSection.thankYouMessageDisplayTimeInMilliSec, heading = _data_searchHelpArticles_articleFeedbackSection.heading, positiveFeedbackIcon = _data_searchHelpArticles_articleFeedbackSection.positiveFeedbackIcon, negativeFeedbackIcon = _data_searchHelpArticles_articleFeedbackSection.negativeFeedbackIcon, negativeFeedbackSection = _data_searchHelpArticles_articleFeedbackSection.negativeFeedbackSection, thankYouMessage = _data_searchHelpArticles_articleFeedbackSection.thankYouMessage;
    var handleThankYouMessage = function(delayTime) {
        setShowThankYouMessage(true);
        setTimeout(function() {
            setShowThankYouMessage(false);
        }, delayTime);
    };
    var ratingClickHandler = function(rating) {
        if (rating === "POSITIVE" /* POSITIVE */ ) {
            setShowFeedbackOptions(false);
            handleThankYouMessage(thankYouMessageDisplayTimeInMilliSec);
            setDisableFeedbackButtons(true);
            var articleGroup = getArticleGroup({
                product: articleIdentifier.product,
                searchTerm: articleIdentifier.searchTerm
            });
            track(buildClickStreamAnalyticsForArticleFeedbackSubmittedEvent({
                type: "Positive",
                articleData: {
                    documentId: articleIdentifier.articleId || "",
                    articleName: articleIdentifier.articleTitle || "",
                    articleGroup: articleGroup || "",
                    searchTerm: articleIdentifier.searchTerm || ""
                },
                negative_options: null
            }));
            logEvents.HELP_ARTICLE_FEEDBACK_SUBMIT.log(stringify(flattenJson({
                message: "feedback submitted for article id: ".concat(articleIdentifier.articleId)
            })));
        } else if (rating === "NEGATIVE" /* NEGATIVE */ ) {
            setShowFeedbackOptions(true);
        } else {
            setShowFeedbackOptions(false);
        }
    };
    var updateCheckStatus = function(idx) {
        var updateOptions = selectedFeedbackOptions.map(function(option, currentIdx) {
            return currentIdx === idx ? _object_spread_props(_object_spread({}, option), {
                checked: !option.checked
            }) : option;
        });
        setSelectedFeedbackOptions(updateOptions);
    };
    var submitFeedback = function(event) {
        event.preventDefault();
        handleThankYouMessage(thankYouMessageDisplayTimeInMilliSec);
        setDisableFeedbackButtons(true);
        logEvents.HELP_ARTICLE_FEEDBACK_SUBMIT.log(stringify(flattenJson({
            message: "feedback submitted for article id: ".concat(articleIdentifier.articleId)
        })));
        var feedbackList = [];
        selectedFeedbackOptions.forEach(function(option) {
            if (option.checked) {
                feedbackList.push(option.label);
            }
        });
        var articleGroup = getArticleGroup({
            product: articleIdentifier.product,
            searchTerm: articleIdentifier.searchTerm
        });
        track(buildClickStreamAnalyticsForArticleFeedbackSubmittedEvent({
            type: "Negative",
            articleData: {
                documentId: articleIdentifier.articleId || "",
                articleName: articleIdentifier.articleTitle || "",
                articleGroup: articleGroup || "",
                searchTerm: articleIdentifier.searchTerm || ""
            },
            negative_options: feedbackList
        }));
    };
    return /* @__PURE__ */ React31.createElement(EGDSSpacing9, {
        margin: marginFeedbackView
    }, /* @__PURE__ */ React31.createElement("div", null, /* @__PURE__ */ React31.createElement(EGDSHeading8, {
        tag: "h6",
        size: 6
    }, heading), /* @__PURE__ */ React31.createElement(ArticleRating, {
        positiveFeedbackIcon: positiveFeedbackIcon.id,
        negativeFeedbackIcon: negativeFeedbackIcon.id,
        positiveFeedbackAriaLabel: positiveFeedbackIcon.title || "",
        negativeFeedbackAriaLabel: negativeFeedbackIcon.title || "",
        disabled: disableFeedbackButtons,
        onChange: ratingClickHandler
    }), showFeedbackOptions && /* @__PURE__ */ React31.createElement(React31.Fragment, null, /* @__PURE__ */ React31.createElement(EGDSSpacing9, {
        margin: marginInnerFeedbackView2
    }, /* @__PURE__ */ React31.createElement(EGDSText6, null, negativeFeedbackSection.optionsTitle)), /* @__PURE__ */ React31.createElement(EGDSForm, {
        onSubmit: submitFeedback
    }, /* @__PURE__ */ React31.createElement(EGDSSpacing9, {
        margin: marginInnerFeedbackView2
    }, /* @__PURE__ */ React31.createElement(EGDSCheckboxGroup, {
        group: "checkboxGroup"
    }, selectedFeedbackOptions.map(function(feedbackOption, feedbackOptionIndex) {
        return /* @__PURE__ */ React31.createElement(EGDSCheckbox, {
            disabled: disableFeedbackButtons,
            key: "feedback-option-index-".concat(feedbackOptionIndex),
            id: "feedback-option-checkbox-".concat(feedbackOptionIndex),
            checked: feedbackOption.checked,
            onChange: function() {
                return updateCheckStatus(feedbackOptionIndex);
            }
        }, feedbackOption.label);
    }))), /* @__PURE__ */ React31.createElement(EGDSSpacing9, {
        margin: marginInnerFeedbackView2
    }, /* @__PURE__ */ React31.createElement(EGDSPrimaryButton2, {
        disabled: !selectedFeedbackOptions.some(function(el) {
            return el.checked;
        }) || disableFeedbackButtons,
        type: "submit"
    }, negativeFeedbackSection.submitButton.primary)))), showThankYouMessage && /* @__PURE__ */ React31.createElement(EGDSSpacing9, {
        margin: marginInnerFeedbackView2
    }, /* @__PURE__ */ React31.createElement(EGDSText6, null, thankYouMessage))));
};
ArticleFeedbackView.displayName = "ArticleFeedbackView";
// src/components/help-articles/_private/__fragments/article/__fragments/__fragments/category-view.tsx
import React32 from "react";
import { gql as gql25 } from "@apollo/client";
import { EGDSIcon as EGDSIcon8, EGDSIconSize as EGDSIconSize6 } from "@egds/react-core/icons";
import { EGDSLink as EGDSLink5 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing10 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText7 } from "@egds/react-core/text";
var __categoryFragment = gql25(_templateObject24());
var categoryLinkMargin = {
    inline: "one"
};
var CategoryView = function(param) {
    var data = param.data, lastOne = param.lastOne, onClick = param.onClick;
    var _data_icon;
    return /* @__PURE__ */ React32.createElement(EGDSText7, null, /* @__PURE__ */ React32.createElement(EGDSSpacing10, {
        margin: categoryLinkMargin
    }, /* @__PURE__ */ React32.createElement(EGDSLink5, {
        key: data.headingText,
        onClick: function() {
            return onClick(data.headingText);
        }
    }, /* @__PURE__ */ React32.createElement("button", {
        type: "button",
        key: "button"
    }, ((_data_icon = data.icon) === null || _data_icon === void 0 ? void 0 : _data_icon.id) && /* @__PURE__ */ React32.createElement(EGDSIcon8, {
        name: data.icon.id,
        size: EGDSIconSize6.EXTRA_SMALL,
        key: "icon"
    }), data.headingText, !lastOne && ","))));
};
CategoryView.fragment = __categoryFragment;
CategoryView.displayName = "CategoryView";
// src/components/help-articles/_private/__fragments/article/__fragments/__fragments/clickstream-analytics.ts
import { gql as gql26 } from "@apollo/client";
var HelpArticleClickStreamAnalyticsFragment = gql26(_templateObject25());
// src/components/help-articles/_private/__fragments/article/__fragments/__fragments/contact-us-prefill.tsx
import { gql as gql27 } from "@apollo/client";
var ContactUsPreFillFragment = gql27(_templateObject26());
// src/components/help-articles/_private/__fragments/article/__fragments/__fragments/contact-us-widget.tsx
import React34 from "react";
import { gql as gql29 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing11, EGDSSpacingHr as EGDSSpacingHr4 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading9 } from "@egds/react-core/text";
import { useEgClickstream as useEgClickstream4 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/egds-button/egds-button.tsx
import React33 from "react";
import { gql as gql28 } from "@apollo/client";
import { EGDSPrimaryButton as EGDSPrimaryButton3, EGDSSecondaryButton as EGDSSecondaryButton2, EGDSTertiaryButton } from "@egds/react-core/button";
var __fragment8 = gql28(_templateObject27(), HelpCenterEGDSIcon.fragment);
var HelpCenterEGDSButton = function(_param) {
    var data = _param.data, onClickHandler = _param.onClickHandler, isDisabled = _param.isDisabled, type = _param.type, _param_iconPosition = _param.iconPosition, iconPosition = _param_iconPosition === void 0 ? "LEADING" /* LEADING */  : _param_iconPosition, otherProps = _object_without_properties(_param, [
        "data",
        "onClickHandler",
        "isDisabled",
        "type",
        "iconPosition"
    ]);
    var primary = data.primary, disabled = data.disabled, accessibility = data.accessibility, __typename = data.__typename, icon = data.icon;
    var buttonProps = {
        disabled: disabled || isDisabled,
        title: accessibility,
        type: type,
        onClick: onClickHandler
    };
    switch(__typename){
        case "UIPrimaryButton":
            return /* @__PURE__ */ React33.createElement(EGDSPrimaryButton3, _object_spread({}, buttonProps, otherProps), icon && iconPosition === "LEADING" /* LEADING */  && /* @__PURE__ */ React33.createElement(HelpCenterEGDSIcon, {
                data: icon
            }), primary, icon && iconPosition === "TRAILING" /* TRAILING */  && /* @__PURE__ */ React33.createElement(HelpCenterEGDSIcon, {
                data: icon
            }));
        case "UISecondaryButton":
            return /* @__PURE__ */ React33.createElement(EGDSSecondaryButton2, _object_spread({}, buttonProps, otherProps), icon && iconPosition === "LEADING" /* LEADING */  && /* @__PURE__ */ React33.createElement(HelpCenterEGDSIcon, {
                data: icon
            }), primary, icon && iconPosition === "TRAILING" /* TRAILING */  && /* @__PURE__ */ React33.createElement(HelpCenterEGDSIcon, {
                data: icon
            }));
        case "UITertiaryButton":
            return /* @__PURE__ */ React33.createElement(EGDSTertiaryButton, _object_spread({}, buttonProps, otherProps), icon && iconPosition === "LEADING" /* LEADING */  && /* @__PURE__ */ React33.createElement(HelpCenterEGDSIcon, {
                data: icon
            }), primary, icon && iconPosition === "TRAILING" /* TRAILING */  && /* @__PURE__ */ React33.createElement(HelpCenterEGDSIcon, {
                data: icon
            }));
        default:
            return null;
    }
};
HelpCenterEGDSButton.displayName = "HelpCenterEGDSButton";
HelpCenterEGDSButton.fragment = __fragment8;
// src/components/help-articles/_private/__fragments/article/__fragments/__fragments/contact-us-widget.tsx
var __fragment9 = gql29(_templateObject28(), HelpCenterEGDSButton.fragment);
var marginContactUsWidget = {
    block: "four"
};
var ContactUsWidget = function(param) {
    var data = param.data;
    var _useArticle = useArticle(), contactUsDialogActions = _useArticle.contactUsDialogActions, articleDialogActions = _useArticle.articleDialogActions;
    var track = useEgClickstream4();
    var articleIdentifier = useArticle().articleIdentifier;
    var handleContactUsButtonClick = React34.useCallback(function() {
        var articleGroup = getArticleGroup({
            product: articleIdentifier.product,
            searchTerm: articleIdentifier.searchTerm
        });
        track(buildClickStreamAnalyticsForContactUsSelectedEvent(articleIdentifier.articleId, articleIdentifier.articleTitle, articleGroup, articleIdentifier.searchTerm));
    }, [
        articleIdentifier
    ]);
    return /* @__PURE__ */ React34.createElement(React34.Fragment, null, /* @__PURE__ */ React34.createElement(EGDSSpacingHr4, {
        blockMargin: "four"
    }), /* @__PURE__ */ React34.createElement(EGDSSpacing11, {
        margin: marginContactUsWidget
    }, /* @__PURE__ */ React34.createElement(EGDSHeading9, {
        tag: "h6",
        size: 6
    }, data.headingText)), /* @__PURE__ */ React34.createElement(EGDSSpacing11, {
        margin: marginContactUsWidget
    }, /* @__PURE__ */ React34.createElement(HelpCenterEGDSButton, {
        data: data.contactUsButton,
        onClickHandler: function() {
            articleDialogActions.closeDialog();
            setTimeout(function() {
                return contactUsDialogActions.openDialog();
            }, 100);
            handleContactUsButtonClick();
        },
        type: "button"
    })));
};
ContactUsWidget.fragment = __fragment9;
ContactUsWidget.displayName = "ContactUsWidget";
// src/components/help-articles/_private/__fragments/article/__fragments/__fragments/help-article-content-display-view.tsx
import React39, { useCallback as useCallback6 } from "react";
import { gql as gql34 } from "@apollo/client";
import { useEgClickstream as useEgClickstream5 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/egds-search-form-action/egds-search-form-selection.tsx
import React37 from "react";
import { gql as gql32 } from "@apollo/client";
import { EGDSSelect } from "@egds/react-core/input";
import { EGDSLayoutFlex as EGDSLayoutFlex7, EGDSLayoutFlexItem as EGDSLayoutFlexItem7 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing12 } from "@egds/react-core/spacing";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/egds-select/egds-option.tsx
import React36 from "react";
import { gql as gql31 } from "@apollo/client";
// ../internal/src/components/egds-select/egds-basic-option.tsx
import React35 from "react";
import { gql as gql30 } from "@apollo/client";
var __Fragment = gql30(_templateObject29());
var EGDSBasicOption = function(param) {
    var data = param.data;
    var _data_selected;
    return /* @__PURE__ */ React35.createElement("option", {
        key: data.value,
        value: data.value,
        "aria-selected": (_data_selected = data.selected) !== null && _data_selected !== void 0 ? _data_selected : false
    }, data.label);
};
EGDSBasicOption.displayName = "EGDSBasicOption";
EGDSBasicOption.fragment = __Fragment;
// ../internal/src/components/egds-select/egds-option.tsx
var __Fragment2 = gql31(_templateObject30(), EGDSBasicOption.fragment);
var EGDSOption = function(param) {
    var data = param.data;
    switch(data.__typename){
        case "EGDSBasicOption":
            return /* @__PURE__ */ React36.createElement(EGDSBasicOption, {
                data: data
            });
        default:
            return null;
    }
};
EGDSOption.displayName = "EGDSOption";
EGDSOption.fragment = __Fragment2;
// ../internal/src/components/egds-search-form-action/egds-search-form-selection.tsx
var __fragment10 = gql32(_templateObject31(), EGDSOption.fragment, HelpCenterEGDSButton.fragment);
var margin = {
    blockstart: "four"
};
var EGDSSearchFormSelectAction = function(param) {
    var data = param.data;
    var apply = data.apply, options = data.options, analytics = data.analytics, label = data.label;
    var _React37_useState = _sliced_to_array(React37.useState(""), 2), selectedValue = _React37_useState[0], setSelectedValue = _React37_useState[1];
    var track = useClickTracker();
    var handleOnChange = function(event) {
        setSelectedValue(event.target.value);
    };
    var handleButtonClick = function() {
        if (analytics) {
            var referrerId = analytics.referrerId, linkName = analytics.linkName;
            track(referrerId, linkName);
        }
        if (selectedValue) {
            window.open(selectedValue, "RNnew", "");
        }
    };
    return /* @__PURE__ */ React37.createElement(EGDSSpacing12, {
        margin: margin
    }, /* @__PURE__ */ React37.createElement(EGDSLayoutFlex7, {
        space: "four"
    }, /* @__PURE__ */ React37.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */ React37.createElement(EGDSSelect, {
        onChange: handleOnChange,
        label: label || void 0,
        emptyState: true
    }, options.map(function(optionItem, index) {
        return /* @__PURE__ */ React37.createElement(EGDSOption, {
            data: optionItem,
            key: "option-".concat(index)
        });
    }))), apply && /* @__PURE__ */ React37.createElement(HelpCenterEGDSButton, {
        data: apply,
        onClickHandler: handleButtonClick
    })));
};
EGDSSearchFormSelectAction.displayName = "EGDSSearchFormSelectAction";
EGDSSearchFormSelectAction.fragment = __fragment10;
// ../internal/src/components/help-article-table/help-article-table.tsx
import React38 from "react";
import { gql as gql33 } from "@apollo/client";
import { EGDSTable, EGDSTableBody, EGDSTableCell, EGDSTableCellBorder, EGDSTableHead, EGDSTableRow } from "@egds/react-core/tables";
var __fragment11 = gql33(_templateObject32(), EGDSPlainText.fragment, HelpCenterEGDSHeading.fragment, EGDSInlineLink.fragment, EGDSStylizedText.fragment, EGDSSpannableText.fragment);
var ComponentMap2 = {
    EGDSPlainText: EGDSPlainText,
    EGDSHeading: HelpCenterEGDSHeading,
    EGDSSpannableText: EGDSSpannableText,
    EGDSStylizedText: EGDSStylizedText
};
var HelpArticleTable = function(param) {
    var data = param.data;
    var width = "".concat(100 / data.header.length, "%");
    var _data_caption;
    return /* @__PURE__ */ React38.createElement(EGDSTable, {
        border: true,
        caption: (_data_caption = data.caption) !== null && _data_caption !== void 0 ? _data_caption : void 0
    }, /* @__PURE__ */ React38.createElement(EGDSTableHead, null, /* @__PURE__ */ React38.createElement(EGDSTableRow, null, data.header.map(function(headerText, headerIndex) {
        return /* @__PURE__ */ React38.createElement(EGDSTableCell, {
            key: "header-column-".concat(headerIndex),
            border: [
                EGDSTableCellBorder.horizontal,
                EGDSTableCellBorder.vertical
            ],
            columnWidth: width,
            align: {
                horizontal: "leading",
                vertical: "top"
            }
        }, headerText);
    }))), /* @__PURE__ */ React38.createElement(EGDSTableBody, null, data.body.rows.map(function(tableRow, rowIndex) {
        return /* @__PURE__ */ React38.createElement(EGDSTableRow, {
            key: "body-row-".concat(rowIndex)
        }, tableRow.cells.map(function(tableCell, cellIndex) {
            return /* @__PURE__ */ React38.createElement(EGDSTableCell, {
                key: "body-column-".concat(cellIndex),
                border: [
                    EGDSTableCellBorder.horizontal,
                    EGDSTableCellBorder.vertical
                ],
                align: {
                    vertical: "top"
                }
            }, tableCell.content.map(function(contentData, cellDataIndex) {
                var Component = contentData && ComponentMap2[contentData.__typename];
                if (!Component) {
                    return null;
                }
                return /* @__PURE__ */ React38.createElement(Component, {
                    data: contentData,
                    key: cellDataIndex
                });
            }));
        }));
    })));
};
HelpArticleTable.fragment = __fragment11;
HelpArticleTable.displayName = "HelpArticleTable";
// src/components/help-articles/_private/__fragments/article/__fragments/__fragments/help-article-content-display-view.tsx
var __articleDisplayFragment = gql34(_templateObject33(), EGDSPlainText.fragment, EGDSStylizedText.fragment, EGDSInlineLink.fragment, HelpCenterEGDSHeading.fragment, EGDSSpannableText.fragment, EGDSOrderedList.fragment, EGDSUnorderedList.fragment, EGDSSearchFormSelectAction.fragment, HelpArticleTable.fragment);
var ComponentMap3 = {
    EGDSPlainText: EGDSPlainText,
    EGDSHeading: HelpCenterEGDSHeading,
    EGDSSpannableText: EGDSSpannableText,
    EGDSStylizedText: EGDSStylizedText,
    EGDSOrderedList: EGDSOrderedList,
    EGDSUnorderedList: EGDSUnorderedList,
    EGDSSearchFormSelectAction: EGDSSearchFormSelectAction,
    HelpArticleTable: HelpArticleTable
};
var ComponentStyleMap2 = {
    EGDSOrderedList: {
        type: "ordered"
    },
    EGDSUnorderedList: {
        type: "unordered"
    }
};
var HelpArticleDisplayView = function(param) {
    var helpArticlePortableTextContent = param.data.helpArticlePortableTextContent;
    var _useArticle = useArticle(), setArticleIdentifier = _useArticle.setArticleIdentifier, articleIdentifier = _useArticle.articleIdentifier, contactUsDialogActions = _useArticle.contactUsDialogActions, articleDialogActions = _useArticle.articleDialogActions;
    var track = useEgClickstream5();
    var onLinkClickCapture = function(articleLinkType, articleLinkUrl, articleLinkText) {
        var searchTerm = articleIdentifier.searchTerm;
        var articleGroup = getArticleGroup({
            product: articleIdentifier.product,
            searchTerm: searchTerm
        });
        track(buildClickstreamAnalyticsForExternalArticles(articleLinkUrl, articleLinkType, articleLinkText, articleGroup, searchTerm));
    };
    var articleDialogHandler = useCallback6(function(articleId, articleLink) {
        setArticleIdentifier({
            articleLink: articleLink,
            articleIdentifier: _object_spread_props(_object_spread({}, articleIdentifier), {
                articleId: articleId
            })
        });
    }, [
        articleIdentifier,
        setArticleIdentifier
    ]);
    var onLinkClickHandler = function(event) {
        var currentTarget = event === null || event === void 0 ? void 0 : event.currentTarget;
        var url = currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.getAttribute("href");
        if (url === null || url === void 0 ? void 0 : url.startsWith("#")) {
            event.preventDefault();
            var articleId = url.substring(url.lastIndexOf("/") + 1);
            if (articleId === "contact-us") {
                articleDialogActions.closeDialog();
                setTimeout(function() {
                    contactUsDialogActions.openDialog();
                }, 100);
            } else {
                articleDialogHandler(articleId, url);
            }
        }
        var targetType = (currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.getAttribute("target")) === "_blank" ? "EXTERNAL" /* EXTERNAL */  : "INTERNAL" /* INTERNAL */ ;
        var cloneTarget = currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.cloneNode(true);
        while(cloneTarget === null || cloneTarget === void 0 ? void 0 : cloneTarget.firstElementChild){
            cloneTarget.removeChild(cloneTarget.firstElementChild);
        }
        var linkText = cloneTarget === null || cloneTarget === void 0 ? void 0 : cloneTarget.text;
        onLinkClickCapture(url, targetType, linkText);
    };
    return /* @__PURE__ */ React39.createElement(React39.Fragment, null, helpArticlePortableTextContent.map(function(element, index) {
        var Component = element && ComponentMap3[element.__typename];
        if (!Component) {
            return null;
        }
        if (element.__typename === "EGDSSpannableText" || element.__typename === "EGDSUnorderedList" || element.__typename === "EGDSOrderedList") {
            return /* @__PURE__ */ React39.createElement(Component, _object_spread({
                data: element,
                key: index
            }, ComponentStyleMap2[element.__typename], {
                onLinkClickHandler: onLinkClickHandler
            }));
        }
        return /* @__PURE__ */ React39.createElement(Component, _object_spread({
            data: element,
            key: index
        }, ComponentStyleMap2[element.__typename]));
    }));
};
HelpArticleDisplayView.fragment = __articleDisplayFragment;
HelpArticleDisplayView.displayName = "HelpArticleDisplayView";
// src/components/help-articles/_private/__fragments/article/__fragments/__fragments/product-view.tsx
import React40 from "react";
import { gql as gql35 } from "@apollo/client";
import { EGDSIcon as EGDSIcon9, EGDSIconSize as EGDSIconSize7 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex8 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink6 } from "@egds/react-core/link";
import { EGDSText as EGDSText8 } from "@egds/react-core/text";
var __productFragment = gql35(_templateObject34());
var ProductView = function(param) {
    var product = param.product, data = param.data, handleProductLinkClick = param.handleProductLinkClick;
    var _data_icon;
    return /* @__PURE__ */ React40.createElement(EGDSLayoutFlex8, {
        direction: "row",
        alignContent: "start"
    }, /* @__PURE__ */ React40.createElement(EGDSText8, null, /* @__PURE__ */ React40.createElement(EGDSLink6, {
        key: product,
        onClick: handleProductLinkClick
    }, /* @__PURE__ */ React40.createElement("button", {
        type: "button",
        key: "button"
    }, product, product && ((_data_icon = data.icon) === null || _data_icon === void 0 ? void 0 : _data_icon.id) && /* @__PURE__ */ React40.createElement(EGDSIcon9, {
        name: data.icon.id,
        size: EGDSIconSize7.SMALL,
        key: "icon"
    })))), /* @__PURE__ */ React40.createElement(EGDSText8, null, data.headingText));
};
ProductView.fragment = __productFragment;
ProductView.displayName = "ArticleProductView";
// src/components/help-articles/_private/__fragments/article/__fragments/article-content-view.tsx
var __fragment12 = gql36(_templateObject35(), CategoryView.fragment, ProductView.fragment, HelpArticleDisplayView.fragment, HelpArticleClickStreamAnalyticsFragment, ContactUsPreFillFragment);
var marginAtTitles = {
    block: "four"
};
var ArticleContentView = function(param) {
    var contactUsWidget = param.contactUsWidget, data = param.data;
    var _helpArticleClickStreamAnalytics_article, _data_contactUsPreFill, _data_contactUsPreFill1;
    var _useArticle = useArticle(), setArticleIdentifier = _useArticle.setArticleIdentifier, actionLocation = _useArticle.actionLocation, articleLink = _useArticle.articleLink, articleIdentifier = _useArticle.articleIdentifier, setPreFillContactUsForm = _useArticle.setPreFillContactUsForm;
    var callerContext = useCallerContext().callerContext;
    var productTitle = data.productTitle, productId = data.productId, heading = data.heading, categories = data.categories, moreAboutCategory = data.moreAboutCategory, helpArticleContent = data.helpArticleContent, helpArticleClickStreamAnalytics = data.helpArticleClickStreamAnalytics;
    var track = useEgClickstream6();
    var onProductViewClick = useCallback8(function() {
        if (articleIdentifier.searchTerm) {
            setArticleIdentifier({
                articleIdentifier: {
                    searchTerm: productTitle
                }
            });
        } else {
            var isCategory = categories && productTitle && categories.some(function(category) {
                return category.headingText === productTitle;
            }) || false;
            setArticleIdentifier({
                articleIdentifier: {
                    product: productTitle,
                    productId: productId,
                    isCategory: isCategory
                }
            });
        }
        var articleGroup = getArticleGroup({
            product: articleIdentifier.product,
            searchTerm: articleIdentifier.searchTerm
        });
        var clickStreamEventData = buildClickStreamAnalyticsEventObject(HELP_ARTICLE_NAVIGATION_SELECTED_EVENT_NAME, HELP_ARTICLE_NAVIGATION_BAR_EVENT_VERSION, {
            documentId: articleIdentifier.articleId || "",
            articleName: articleIdentifier.articleTitle || "",
            articleGroup: articleGroup || "",
            searchTerm: articleIdentifier.searchTerm || ""
        });
        track(clickStreamEventData);
    }, [
        articleIdentifier.searchTerm,
        productTitle,
        categories,
        setArticleIdentifier
    ]);
    var categoryClickHandler = function(product) {
        setArticleIdentifier({
            articleIdentifier: {
                product: product,
                isCategory: true
            }
        });
        var articleGroup = getArticleGroup({
            product: articleIdentifier.product,
            searchTerm: articleIdentifier.searchTerm
        });
        var clickStreamEventData = buildClickStreamAnalyticsForCategoryEvent({
            documentId: articleIdentifier.articleId || "",
            articleName: articleIdentifier.articleTitle || "",
            articleGroup: articleGroup || "",
            searchTerm: articleIdentifier.searchTerm || ""
        }, product);
        track(clickStreamEventData);
    };
    var categoriesMemo = React41.useMemo(function() {
        if (categories) {
            return categories.map(function(categoryItem, index) {
                return /* @__PURE__ */ React41.createElement(CategoryView, {
                    key: index,
                    data: categoryItem,
                    lastOne: categories.length === index + 1,
                    onClick: categoryClickHandler
                });
            });
        }
        return null;
    }, [
        categories,
        categoryClickHandler
    ]);
    React41.useEffect(function() {
        if (helpArticleClickStreamAnalytics) {
            var _helpArticleClickStreamAnalytics_article, _helpArticleClickStreamAnalytics_article1;
            var articleGroup = getArticleGroup({
                product: (_helpArticleClickStreamAnalytics_article = helpArticleClickStreamAnalytics.article) === null || _helpArticleClickStreamAnalytics_article === void 0 ? void 0 : _helpArticleClickStreamAnalytics_article.articleGroup,
                searchTerm: (_helpArticleClickStreamAnalytics_article1 = helpArticleClickStreamAnalytics.article) === null || _helpArticleClickStreamAnalytics_article1 === void 0 ? void 0 : _helpArticleClickStreamAnalytics_article1.searchTerm
            });
            var clickStreamEventData = buildClickstreamAnalyticsEvent(helpArticleClickStreamAnalytics, actionLocation, articleGroup, articleLink);
            track(clickStreamEventData);
        }
    }, [
        (_helpArticleClickStreamAnalytics_article = helpArticleClickStreamAnalytics.article) === null || _helpArticleClickStreamAnalytics_article === void 0 ? void 0 : _helpArticleClickStreamAnalytics_article.documentId
    ]);
    React41.useEffect(function() {
        if (data.contactUsPreFill) {
            var _data_contactUsPreFill, _data_contactUsPreFill1;
            setPreFillContactUsForm({
                phoneNumber: "",
                itineraryNumber: "",
                category: ((_data_contactUsPreFill = data.contactUsPreFill) === null || _data_contactUsPreFill === void 0 ? void 0 : _data_contactUsPreFill.product) || "",
                intent: ((_data_contactUsPreFill1 = data.contactUsPreFill) === null || _data_contactUsPreFill1 === void 0 ? void 0 : _data_contactUsPreFill1.category) || ""
            });
        }
    }, [
        data.contactUsPreFill,
        (_data_contactUsPreFill = data.contactUsPreFill) === null || _data_contactUsPreFill === void 0 ? void 0 : _data_contactUsPreFill.category,
        (_data_contactUsPreFill1 = data.contactUsPreFill) === null || _data_contactUsPreFill1 === void 0 ? void 0 : _data_contactUsPreFill1.product,
        setPreFillContactUsForm
    ]);
    return /* @__PURE__ */ React41.createElement(React41.Fragment, null, callerContext !== 1 /* QnA */  && /* @__PURE__ */ React41.createElement(React41.Fragment, null, /* @__PURE__ */ React41.createElement(ProductView, {
        product: productTitle,
        data: heading,
        handleProductLinkClick: onProductViewClick
    }), /* @__PURE__ */ React41.createElement(EGDSSpacingHr5, {
        blockMargin: "three"
    })), helpArticleContent && /* @__PURE__ */ React41.createElement(HelpArticleDisplayView, {
        data: helpArticleContent
    }), callerContext !== 1 /* QnA */  && /* @__PURE__ */ React41.createElement(React41.Fragment, null, /* @__PURE__ */ React41.createElement(EGDSSpacingHr5, {
        blockMargin: "four"
    }), /* @__PURE__ */ React41.createElement(EGDSSpacing13, {
        margin: marginAtTitles
    }, /* @__PURE__ */ React41.createElement(EGDSLayoutFlex9, null, /* @__PURE__ */ React41.createElement(EGDSText9, null, moreAboutCategory), categoriesMemo))), callerContext !== 1 /* QnA */  && /* @__PURE__ */ React41.createElement(ArticleFeedbackView, {
        inputs: {}
    }), contactUsWidget && callerContext !== 1 /* QnA */  && /* @__PURE__ */ React41.createElement(ContactUsWidget, {
        data: contactUsWidget
    }));
};
ArticleContentView.displayName = "ArticleContentView";
ArticleContentView.fragment = __fragment12;
// src/components/help-articles/_private/__fragments/article/article-query.tsx
var ARTICLE_DATA_LOADING_ERROR = "Error while loading article dialog content";
var __ArticleQuery = gql37(_templateObject36(), ArticleContentView.fragment, HelpArticleErrorView.fragment);
var ArticleWithQuery = function(props) {
    var inputs = props.inputs, dialogId = props.dialogId;
    var context = useBexApi2().context;
    var logEvents = useLoggerEvents3(EVENTS2);
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var errorViewMargin3 = {
        block: "twelve"
    };
    var _useQuery2 = useQuery2(__ArticleQuery, {
        variables: variables,
        ssr: false
    }), data = _useQuery2.data, error = _useQuery2.error, loading = _useQuery2.loading;
    if (loading) {
        return /* @__PURE__ */ React42.createElement(SheetLoader, {
            isSmall: true
        });
    }
    if (error || !data) {
        logEvents.ARTICLE_DATA_LOADING_ERROR.log(stringify(flattenJson({
            message: "".concat(ARTICLE_DATA_LOADING_ERROR)
        })));
        return null;
    }
    switch(data.searchHelpArticles.articlesById.__typename){
        case "HelpArticleData":
            return /* @__PURE__ */ React42.createElement(ArticleContentView, {
                data: data.searchHelpArticles.articlesById,
                contactUsWidget: props.contactUsWidget
            });
        case "HelpArticleErrorView":
            return /* @__PURE__ */ React42.createElement(EGDSSpacing14, {
                margin: errorViewMargin3
            }, /* @__PURE__ */ React42.createElement(HelpArticleErrorView, {
                data: data.searchHelpArticles.articlesById
            }));
        default:
            return null;
    }
};
ArticleWithQuery.displayName = "ArticleWithQuery";
// src/components/help-articles/_private/__fragments/article/article-content-dialog.tsx
import React49, { useCallback as useCallback9, useEffect as useEffect3 } from "react";
import { EGDSSheetContent, EGDSSheetTransition as EGDSSheetTransition2 } from "@egds/react-core/sheet";
// ../internal/src/components/view/sheet-view-port.tsx
import React43 from "react";
import { EGDSSheet } from "@egds/react-core/sheet";
import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
var SheetViewPort = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    return /* @__PURE__ */ React43.createElement(Viewport, null, /* @__PURE__ */ React43.createElement(ViewSmall, null, /* @__PURE__ */ React43.createElement(EGDSSheet, _object_spread_props(_object_spread({}, props), {
        type: "full"
    }), children)), /* @__PURE__ */ React43.createElement(ViewLarge, null, /* @__PURE__ */ React43.createElement(EGDSSheet, _object_spread_props(_object_spread({}, props), {
        type: "centered"
    }), children)));
};
// src/components/help-articles/contact-us.tsx
import React44 from "react";
import { EGDSSheetTransition } from "@egds/react-core/sheet";
import { ContactUsForm } from "@shared-ui/retail-help-center-contact-us";
var ContactUs = function() {
    var _useArticle = useArticle(), contactUsDialogActions = _useArticle.contactUsDialogActions, ContactUsDialogComponent = _useArticle.ContactUsDialogComponent, isContactUsDialogOpen = _useArticle.isContactUsDialogOpen, preFillContactUsForm = _useArticle.preFillContactUsForm;
    return /* @__PURE__ */ React44.createElement(EGDSSheetTransition, {
        isVisible: isContactUsDialogOpen
    }, /* @__PURE__ */ React44.createElement(ContactUsDialogComponent, null, /* @__PURE__ */ React44.createElement(ContactUsForm, {
        isVisible: isContactUsDialogOpen,
        onClose: contactUsDialogActions.closeDialog,
        formInputs: preFillContactUsForm
    })));
};
// src/components/help-articles/_private/__fragments/morearticles/morearticle-query.tsx
import React46 from "react";
import { gql as gql39, useQuery as useQuery3 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing15 } from "@egds/react-core/spacing";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { useLoggerEvents as useLoggerEvents4 } from "@shared-ui/logger-context";
// src/components/help-articles/_private/__fragments/morearticles/__fragments/more-articles-view.tsx
import React45 from "react";
import { gql as gql38 } from "@apollo/client";
import { EGDSLayoutColumns } from "@egds/react-core/layout-columns";
import { EGDSSpacingHr as EGDSSpacingHr6 } from "@egds/react-core/spacing";
var __fragment13 = gql38(_templateObject37(), Article.fragment, HeadingSection.fragment);
var MoreArticlesView = function(param) {
    var data = param.data;
    var helpArticlesInDialogMemo = React45.useMemo(function() {
        return data.helpArticlesInDialog.map(function(articlesData, helpArticleDialogIndex) {
            return /* @__PURE__ */ React45.createElement("div", {
                key: helpArticleDialogIndex
            }, /* @__PURE__ */ React45.createElement(HeadingSection, {
                data: articlesData.helpArticleHeadingSection
            }), /* @__PURE__ */ React45.createElement(EGDSSpacingHr6, {
                blockMargin: "three"
            }), /* @__PURE__ */ React45.createElement(EGDSLayoutColumns, {
                space: "twelve"
            }, articlesData.articlesList.map(function(article, articleIndex) {
                return /* @__PURE__ */ React45.createElement(Article, {
                    data: article,
                    key: articleIndex,
                    fromDialog: true
                });
            })));
        });
    }, [
        data.helpArticlesInDialog
    ]);
    return /* @__PURE__ */ React45.createElement(React45.Fragment, null, helpArticlesInDialogMemo);
};
MoreArticlesView.displayName = "MoreArticlesView";
MoreArticlesView.fragment = __fragment13;
// src/components/help-articles/_private/__fragments/morearticles/morearticle-query.tsx
var MORE_ARTICLE_DATA_LOADING_ERROR = "Error while loading more article dialog content";
var __MoreArticleQuery = gql39(_templateObject38(), MoreArticlesView.fragment, HelpArticleErrorView.fragment);
var errorViewMargin2 = {
    block: "twelve"
};
var MoreArticleWithQuery = function(props) {
    var inputs = props.inputs;
    var context = useBexApi3().context;
    var logEvents = useLoggerEvents4(EVENTS2);
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery3 = useQuery3(__MoreArticleQuery, {
        variables: variables,
        ssr: false
    }), data = _useQuery3.data, error = _useQuery3.error, loading = _useQuery3.loading;
    if (loading) {
        return /* @__PURE__ */ React46.createElement(SheetLoader, {
            isSmall: true
        });
    }
    if (error || !data) {
        logEvents.MORE_ARTICLE_DATA_LOADING_ERROR.log(stringify(flattenJson({
            message: "".concat(MORE_ARTICLE_DATA_LOADING_ERROR)
        })));
        return null;
    }
    switch(data.searchHelpArticles.moreArticles.__typename){
        case "MoreHelpArticles":
            return /* @__PURE__ */ React46.createElement(MoreArticlesView, {
                data: data.searchHelpArticles.moreArticles
            });
        case "HelpArticleErrorView":
            return /* @__PURE__ */ React46.createElement(EGDSSpacing15, {
                margin: errorViewMargin2
            }, /* @__PURE__ */ React46.createElement(HelpArticleErrorView, {
                data: data.searchHelpArticles.moreArticles
            }));
        default:
            return null;
    }
};
MoreArticleWithQuery.displayName = "MoreArticleWithQuery";
// src/components/help-articles/_private/__fragments/morearticles/search-article-query.tsx
import React47 from "react";
import { gql as gql40, useQuery as useQuery4 } from "@apollo/client";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
import { useLoggerEvents as useLoggerEvents5 } from "@shared-ui/logger-context";
var SEARCH_ARTICLE_DATA_LOADING_ERROR = "Error while search for article";
var __ArticleSearchInputQuery = gql40(_templateObject39(), MoreArticlesView.fragment, HelpArticleSearchErrorView.fragment);
var SearchArticleWithQuery = function(param) {
    var inputs = param.inputs;
    var logEvents = useLoggerEvents5(EVENTS2);
    var context = useBexApi4().context;
    var variables = _object_spread({
        context: context
    }, inputs);
    var _useQuery4 = useQuery4(__ArticleSearchInputQuery, {
        ssr: false,
        variables: variables
    }), data = _useQuery4.data, error = _useQuery4.error, loading = _useQuery4.loading;
    if (loading) {
        return /* @__PURE__ */ React47.createElement(SheetLoader, {
            isSmall: true
        });
    }
    if (error || !data) {
        logEvents.SEARCH_ARTICLE_DATA_LOADING_ERROR.log(stringify(flattenJson({
            message: "".concat(SEARCH_ARTICLE_DATA_LOADING_ERROR, " ").concat(error),
            searchTerm: inputs.helpArticlesSearchRequest.helpArticlesSearchTerm || ""
        })));
        return null;
    }
    switch(data.searchHelpArticles.articlesBySearchTerm.__typename){
        case "MoreHelpArticles":
            return /* @__PURE__ */ React47.createElement(MoreArticlesView, {
                data: data.searchHelpArticles.articlesBySearchTerm
            });
        case "HelpArticleSearchErrorView":
            return /* @__PURE__ */ React47.createElement(HelpArticleSearchErrorView, {
                data: data.searchHelpArticles.articlesBySearchTerm
            });
        default:
            return null;
    }
};
SearchArticleWithQuery.displayName = "SearchArticleWithQuery";
// src/components/help-articles/_private/__fragments/article/__fragments/__fragments/tool-bar-view.tsx
import React48, { useEffect as useEffect2, useRef } from "react";
import { gql as gql41 } from "@apollo/client";
import { EGDSToolbar } from "@egds/react-core/toolbar";
import { useEgClickstream as useEgClickstream7 } from "@shared-ui/clickstream-analytics-context";
var __toolBarFragment = gql41(_templateObject40());
var ToolBarView = function(param) {
    var dialogTitle = param.dialogTitle, close = param.close;
    var track = useEgClickstream7();
    var articleIdentifier = useArticle().articleIdentifier;
    var articleId = articleIdentifier.articleId, articleTitle = articleIdentifier.articleTitle, product = articleIdentifier.product, searchTerm = articleIdentifier.searchTerm;
    var ref = useRef(null);
    useEffect2(function() {
        if (ref.current) {
            setTimeout(function() {
                var _ref_current;
                ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.focus();
            }, 100);
        }
    }, [
        ref
    ]);
    var handleClose = React48.useCallback(function() {
        var articleGroup = getArticleGroup({
            product: articleIdentifier.product,
            searchTerm: articleIdentifier.searchTerm
        });
        if (articleId) {
            var clickStreamEventData = buildClickStreamAnalyticsEventObject(HELP_ARTICLE_CLOSED_EVENT_NAME, HELP_ARTICLE_CLOSED_EVENT_VERSION, {
                documentId: articleId,
                articleName: articleTitle || "",
                articleGroup: articleGroup || "",
                searchTerm: searchTerm || ""
            });
            track(clickStreamEventData);
        } else {
            var clickStreamEvent = buildClickStreamEventForMoreDialogClose(articleGroup, searchTerm || "");
            track(clickStreamEvent);
        }
        close();
    }, [
        articleIdentifier
    ]);
    return /* @__PURE__ */ React48.createElement(EGDSToolbar, {
        toolbarTitle: dialogTitle,
        navigationContent: {
            onClick: handleClose,
            navIconLabel: "close",
            navType: "close",
            navButtonRef: ref
        }
    });
};
ToolBarView.displayName = "ArticleToolBarView";
// src/components/help-articles/_private/__fragments/article/article-content-dialog.tsx
var DialogCloseHandler = function(param) {
    var children = param.children, onClose = param.onClose;
    useEffect3(function() {
        return onClose;
    }, []);
    return /* @__PURE__ */ React49.createElement(React49.Fragment, null, children);
};
var ArticleContentDialog = function(param) {
    var dialogTitle = param.dialogTitle, onClose = param.onClose;
    var _useArticle = useArticle(), _useArticle_articleIdentifier = _useArticle.articleIdentifier, articleId = _useArticle_articleIdentifier.articleId, product = _useArticle_articleIdentifier.product, isCategory = _useArticle_articleIdentifier.isCategory, searchTerm = _useArticle_articleIdentifier.searchTerm, productId = _useArticle_articleIdentifier.productId, articleDialogActions = _useArticle.articleDialogActions, setArticleIdentifier = _useArticle.setArticleIdentifier, ArticleDialogComponent = _useArticle.ArticleDialogComponent, setPreviousArticleId = _useArticle.setPreviousArticleId, triggerRef = _useArticle.triggerRef, isArticleDialogOpen = _useArticle.isArticleDialogOpen;
    var updateArticleIdentifier = useCallback9(function() {
        setArticleIdentifier({
            articleIdentifier: {}
        });
        setPreviousArticleId("");
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [
        setArticleIdentifier,
        setPreviousArticleId
    ]);
    var articleQueryMemo = React49.useMemo(function() {
        if (articleId) {
            if (searchTerm) {
                return {
                    helpArticleSearchRequest: {
                        helpArticleId: articleId,
                        helpArticlesSearchTerm: searchTerm
                    }
                };
            }
            return {
                helpArticleSearchRequest: {
                    helpArticleId: articleId,
                    product: product,
                    productId: productId
                }
            };
        }
        if (product) {
            return {
                helpArticleSearchRequest: {
                    product: !isCategory ? product : void 0,
                    productId: !isCategory ? productId : void 0,
                    category: isCategory ? product : void 0
                }
            };
        }
        return null;
    }, [
        isCategory,
        articleId,
        product,
        searchTerm
    ]);
    var searchArticleQueryMemo = React49.useMemo(function() {
        if (!articleId && searchTerm) {
            return {
                helpArticlesSearchRequest: {
                    helpArticlesSearchTerm: searchTerm
                }
            };
        }
        return null;
    }, [
        searchTerm,
        articleId
    ]);
    var showArticle = articleQueryMemo === null || articleQueryMemo === void 0 ? void 0 : articleQueryMemo.helpArticleSearchRequest.helpArticleId;
    var showMoreArticle = !(articleQueryMemo === null || articleQueryMemo === void 0 ? void 0 : articleQueryMemo.helpArticleSearchRequest.helpArticleId) && ((articleQueryMemo === null || articleQueryMemo === void 0 ? void 0 : articleQueryMemo.helpArticleSearchRequest.product) || (articleQueryMemo === null || articleQueryMemo === void 0 ? void 0 : articleQueryMemo.helpArticleSearchRequest.category));
    return /* @__PURE__ */ React49.createElement("div", {
        "data-stid": "articleDialog"
    }, /* @__PURE__ */ React49.createElement(EGDSSheetTransition2, {
        isVisible: isArticleDialogOpen
    }, /* @__PURE__ */ React49.createElement(ArticleDialogComponent, null, /* @__PURE__ */ React49.createElement(DialogCloseHandler, {
        onClose: updateArticleIdentifier
    }, /* @__PURE__ */ React49.createElement(SheetViewPort, {
        isVisible: true,
        triggerRef: triggerRef,
        ariaLabel: dialogTitle
    }, /* @__PURE__ */ React49.createElement(ToolBarView, {
        dialogTitle: dialogTitle,
        close: articleDialogActions.closeDialog
    }), /* @__PURE__ */ React49.createElement(EGDSSheetContent, null, showArticle && /* @__PURE__ */ React49.createElement(ArticleWithQuery, {
        inputs: articleQueryMemo,
        dialogId: "article-dialog"
    }), showMoreArticle && /* @__PURE__ */ React49.createElement(MoreArticleWithQuery, {
        inputs: articleQueryMemo,
        dialogId: "article-dialog"
    }), searchArticleQueryMemo && /* @__PURE__ */ React49.createElement(SearchArticleWithQuery, {
        inputs: searchArticleQueryMemo
    })))))), /* @__PURE__ */ React49.createElement(ContactUs, null));
};
// src/components/help-articles/_private/__fragments/all-articles-view.tsx
var gridMargin = {
    blockstart: "six"
};
var __fragment14 = gql42(_templateObject41(), Article.fragment, ArticleCard.fragment, HeadingSection.fragment, MoreArticleLink.fragment, __toolBarFragment, ContactUsWidget.fragment);
var AllArticlesView = function(param) {
    var urlQueryParam = param.urlQueryParam, data = param.data;
    var setArticleIdentifier = useArticle().setArticleIdentifier;
    useEffect4(function() {
        if (urlQueryParam) {
            setArticleIdentifier({
                articleIdentifier: {
                    articleId: urlQueryParam.articleId || "",
                    product: urlQueryParam.product || "",
                    productId: urlQueryParam.productId || "",
                    searchTerm: urlQueryParam.searchTerm || "",
                    isCategory: Boolean(urlQueryParam.isCategory) || false
                }
            });
        }
    }, [
        urlQueryParam === null || urlQueryParam === void 0 ? void 0 : urlQueryParam.articleId,
        urlQueryParam === null || urlQueryParam === void 0 ? void 0 : urlQueryParam.product,
        urlQueryParam === null || urlQueryParam === void 0 ? void 0 : urlQueryParam.productId,
        urlQueryParam === null || urlQueryParam === void 0 ? void 0 : urlQueryParam.searchTerm,
        urlQueryParam === null || urlQueryParam === void 0 ? void 0 : urlQueryParam.isCategory
    ]);
    var isM2LandingPageEnabled = useExperiment3("Help_Center_Web_Landing_Page_UX_M2").exposure.bucket === 1;
    return /* @__PURE__ */ React50.createElement(React50.Fragment, null, /* @__PURE__ */ React50.createElement(Viewport2, null, /* @__PURE__ */ React50.createElement(ViewSmall2, null, /* @__PURE__ */ React50.createElement(EGDSHeading10, {
        tag: isM2LandingPageEnabled ? "h5" : "h2",
        size: 5
    }, data.helpArticleTitle)), /* @__PURE__ */ React50.createElement(ViewMedium, null, /* @__PURE__ */ React50.createElement(EGDSHeading10, {
        tag: isM2LandingPageEnabled ? "h4" : "h2",
        size: isM2LandingPageEnabled ? 4 : 5
    }, data.helpArticleTitle))), /* @__PURE__ */ React50.createElement(EGDSSpacing16, {
        margin: gridMargin,
        stid: "articleLinks"
    }, /* @__PURE__ */ React50.createElement("div", null, /* @__PURE__ */ React50.createElement(Viewport2, null, /* @__PURE__ */ React50.createElement(ViewLarge2, null, /* @__PURE__ */ React50.createElement(EGDSLayoutGrid, {
        columns: {
            small: 1,
            medium: 2,
            large: 3
        },
        space: "three"
    }, data.helpArticlesOnHomepage.map(function(articlesData, index) {
        return /* @__PURE__ */ React50.createElement(EGDSLayoutGridItem, {
            key: index
        }, /* @__PURE__ */ React50.createElement(ArticleCard, {
            data: articlesData
        }));
    }))), /* @__PURE__ */ React50.createElement(ViewSmall2, null, /* @__PURE__ */ React50.createElement(EGDSLayoutGrid, {
        columns: {
            small: 1,
            medium: 2,
            large: 3
        },
        space: "four"
    }, data.helpArticlesOnHomepage.map(function(articlesData, index) {
        return /* @__PURE__ */ React50.createElement(EGDSLayoutGridItem, {
            key: index
        }, /* @__PURE__ */ React50.createElement(ArticleCard, {
            data: articlesData
        }));
    })))))), /* @__PURE__ */ React50.createElement(ArticleContentDialog, {
        dialogTitle: data.dialogTitleOption.headingText
    }));
};
AllArticlesView.displayName = "AllArticlesView";
AllArticlesView.fragment = __fragment14;
// src/components/help-articles/help-articles.tsx
var ALL_ARTICLE_DATA_LOADING_ERROR = "Error while loading article details module";
var __HelpArticlesQuery = gql43(_templateObject42(), AllArticlesView.fragment, AllArticleErrorView.fragment);
var HelpArticles = function(props) {
    var skipSsr = props.skipSsr, inputs = props.inputs, onDialogChangeCallback = props.onDialogChangeCallback, urlQueryParam = props.urlQueryParam;
    var context = useBexApi5().context;
    var logEvents = useLoggerEvents6(EVENTS2);
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery5 = useQuery5(__HelpArticlesQuery, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery5.data, error = _useQuery5.error, loading = _useQuery5.loading;
    if (loading) {
        return null;
    }
    if (error || !data) {
        logEvents.ALL_ARTICLE_DATA_LOADING_ERROR.log(stringify(flattenJson({
            message: "".concat(ALL_ARTICLE_DATA_LOADING_ERROR, ": ").concat(error)
        })));
        return null;
    }
    switch(data.searchHelpArticles.allArticles.__typename){
        case "AllHelpArticles":
            return /* @__PURE__ */ React51.createElement(ArticleContextProvider, {
                onDialogChangeCallback: onDialogChangeCallback,
                dialogId: "article-dialog"
            }, /* @__PURE__ */ React51.createElement(AllArticlesView, {
                data: data.searchHelpArticles.allArticles,
                urlQueryParam: urlQueryParam
            }));
        case "AllArticlesErrorView":
            return /* @__PURE__ */ React51.createElement(AllArticleErrorView, {
                data: data.searchHelpArticles.allArticles
            });
        default:
            return null;
    }
};
HelpArticles.displayName = "sharedui-HelpArticles";
// src/components/help-articles/stand-alone-articles.tsx
import React52, { useEffect as useEffect5 } from "react";
var StandAloneArticle = function(param) {
    var urlQueryParam = param.urlQueryParam;
    var _useArticle = useArticle(), _useArticle_articleIdentifier = _useArticle.articleIdentifier, articleId = _useArticle_articleIdentifier.articleId, product = _useArticle_articleIdentifier.product, isCategory = _useArticle_articleIdentifier.isCategory, searchTerm = _useArticle_articleIdentifier.searchTerm, setArticleIdentifier = _useArticle.setArticleIdentifier;
    useEffect5(function() {
        if (urlQueryParam) {
            setArticleIdentifier({
                articleIdentifier: {
                    articleId: urlQueryParam.articleId || "",
                    product: urlQueryParam.product || "",
                    productId: urlQueryParam.productId || "",
                    searchTerm: urlQueryParam.searchTerm || "",
                    isCategory: Boolean(urlQueryParam.isCategory) || false
                }
            });
        }
    }, []);
    var articleQueryMemo = React52.useMemo(function() {
        if (articleId) {
            if (searchTerm) {
                return {
                    helpArticleSearchRequest: {
                        helpArticleId: articleId,
                        helpArticlesSearchTerm: searchTerm
                    }
                };
            }
            return {
                helpArticleSearchRequest: {
                    helpArticleId: articleId,
                    product: product
                }
            };
        }
        return null;
    }, [
        isCategory,
        articleId,
        product,
        searchTerm
    ]);
    var showArticle = articleQueryMemo === null || articleQueryMemo === void 0 ? void 0 : articleQueryMemo.helpArticleSearchRequest.helpArticleId;
    return /* @__PURE__ */ React52.createElement(React52.Fragment, null, showArticle && /* @__PURE__ */ React52.createElement(ArticleWithQuery, {
        inputs: articleQueryMemo,
        dialogId: "article-dialog"
    }));
};
var StandAloneArticleWrapper = function(props) {
    return /* @__PURE__ */ React52.createElement(ArticleContextProvider, null, /* @__PURE__ */ React52.createElement(StandAloneArticle, _object_spread({}, props)));
};
export { ArticleContentDialog, ArticleContextProvider, CallerContext, CallerContextType, HelpArticles, HelpArticlesQueryParamProvider, StandAloneArticleWrapper as StandAloneArticle, useArticle, useHelpArticleURLParamsToQueryInputs }; /* istanbul ignore file -- @preserve */ 
//# sourceMappingURL=index.js.map